var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-12",
    cx: 252,
    cy: 351.12,
    rx: 236.06,
    ry: 136.29,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-12",
    d: "M301.06,471.88,61.67,333.66a1.32,1.32,0,0,1,0-2.5l141.9-81.93a4.79,4.79,0,0,1,4.33,0L447.3,387.45a1.32,1.32,0,0,1,0,2.5L305.39,471.88A4.79,4.79,0,0,1,301.06,471.88Z",
    style: {
      opacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 154.91,
    cy: 440.83,
    rx: 37.43,
    ry: 21.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 386.44,
    cy: 325.91,
    rx: 35.66,
    ry: 20.59,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.8,82.61l6,3.47a7.31,7.31,0,0,1-.05-.8V83.54c0-3.09,2.17-4.35,4.85-2.8a9.43,9.43,0,0,1,2.9,2.78c.43-3.89,3.49-5.34,7.2-3.2A16.08,16.08,0,0,1,379,92.9v2.6a6.86,6.86,0,0,1-.61,3l5,2.88a5.94,5.94,0,0,1,2.7,4.66c0,1.72-1.21,2.41-2.7,1.55L350.8,88.83a6,6,0,0,1-2.69-4.67C348.11,82.45,349.31,81.75,350.8,82.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.48,66.67l3.31,1.27V60.65c0-5.78,4.61-7.17,9.62-4.28h0c5,2.89,9.06,9.92,9.06,15.7v1.06a4.9,4.9,0,0,1,4.21.65h0a14.42,14.42,0,0,1,6.52,11.3v.48l4.62,2.67a9.5,9.5,0,0,1,4.3,7.44c0,2.74-1.93,3.85-4.3,2.48L390.48,76.59a9.48,9.48,0,0,1-4.3-7.44C386.18,66.41,388.1,65.3,390.48,66.67Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.53,319.13c2.23-3.07,8.61-6.19,16.81-7.38s16.47-2.82,14.93-7.63c-1.66-5.2-9.15-5.95-16.71-3.44-8.25,2.74-14.75,10.48-15.21,15.6Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.53,319.13c2.23-3.07,8.61-6.19,16.81-7.38s16.47-2.82,14.93-7.63c-1.66-5.2-9.15-5.95-16.71-3.44-8.25,2.74-14.75,10.48-15.21,15.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M406,317.63a.63.63,0,0,0,.57-.31c7.32-12.84,22.34-14,27-12.92a.6.6,0,0,0,.26-1.18c-4.87-1.1-20.63.07-28.29,13.5a.61.61,0,0,0,.48.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.57,317.32s1.84-12,15.21-20.78a93.19,93.19,0,0,0,8.69-7.05c5-4.22,3.35-9.28-3.1-9.63-9.58-.52-17.13,7.07-20.88,17.41A31,31,0,0,0,406.57,317.32Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,313.09a.6.6,0,0,0,.64-.5c3.13-19.34,18.63-28.11,22.74-28.87a.6.6,0,1,0-.22-1.18c-5,.92-20.51,10.06-23.71,29.85a.61.61,0,0,0,.5.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.22,335.19l8.15-2.93s2.4-17.81.18-32.44c-3.31-21.9-21.85-43.11-35.06-47.21-24.36-7.56-24.17,15.46-5.83,28.29C89.6,292.05,103.81,308.74,106.22,335.19Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.22,334.18l-.1,0a1,1,0,0,1-.73-1.14c4.37-20-11.16-57.85-33-69.07a1,1,0,0,1,.88-1.71c22.54,11.57,38.54,50.54,34,71.19A1,1,0,0,1,110.22,334.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.89,346.62c.4-2.37.64-5.85.71-6.71a22,22,0,0,0-1-9c-.44-1.26-1.31-2.49-1.47-3.78s.14-2.44-.19-3.72a9.88,9.88,0,0,0-4.57-6.14c-2.18-1.25-5-1.81-6.23-4-.82-1.48-.63-3.29-.56-5,.1-2.58-.21-5.36-1.87-7.34-2.14-2.56-5.88-3.06-9.19-2.72s-6.59,1.33-9.91,1.06c-5.61-.46-10.4-4.44-16-5.26a17.39,17.39,0,0,0-5.93.24c-2.88.6-5.83,2-7.17,4.62a8.15,8.15,0,0,0,.6,7.71c1.55,2.57,4,4.18,6.59,5.59s4.58,2.95,3.27,6.29a9.35,9.35,0,0,0-.87,3A5.31,5.31,0,0,0,65.81,326,15.63,15.63,0,0,0,71,327.69l6.37,1.3c1.85.38,4.13,1.22,4.22,3.11.06,1.17-.81,2.15-1.27,3.23A6,6,0,0,0,82,341.74a11.53,11.53,0,0,0,6.37,2.73c2.33.34,4.69.3,7,.56a27,27,0,0,1,10.27,3.35,8.88,8.88,0,0,0,2.55,1.16C109.55,349.8,116.64,348.12,116.89,346.62Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.89,346.62c.4-2.37.64-5.85.71-6.71a22,22,0,0,0-1-9c-.44-1.26-1.31-2.49-1.47-3.78s.14-2.44-.19-3.72a9.88,9.88,0,0,0-4.57-6.14c-2.18-1.25-5-1.81-6.23-4-.82-1.48-.63-3.29-.56-5,.1-2.58-.21-5.36-1.87-7.34-2.14-2.56-5.88-3.06-9.19-2.72s-6.59,1.33-9.91,1.06c-5.61-.46-10.4-4.44-16-5.26a17.39,17.39,0,0,0-5.93.24c-2.88.6-5.83,2-7.17,4.62a8.15,8.15,0,0,0,.6,7.71c1.55,2.57,4,4.18,6.59,5.59s4.58,2.95,3.27,6.29a9.35,9.35,0,0,0-.87,3A5.31,5.31,0,0,0,65.81,326,15.63,15.63,0,0,0,71,327.69l6.37,1.3c1.85.38,4.13,1.22,4.22,3.11.06,1.17-.81,2.15-1.27,3.23A6,6,0,0,0,82,341.74a11.53,11.53,0,0,0,6.37,2.73c2.33.34,4.69.3,7,.56a27,27,0,0,1,10.27,3.35,8.88,8.88,0,0,0,2.55,1.16C109.55,349.8,116.64,348.12,116.89,346.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.05,348.83a.87.87,0,0,1-.75-.56c-8-21.07-26.94-37.92-53.39-47.43a.88.88,0,0,1,.59-1.65c26.94,9.69,46.28,26.91,54.44,48.46a.88.88,0,0,1-.51,1.13A.85.85,0,0,1,113.05,348.83Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Analysis--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.37,358.35,109,356.42a4.21,4.21,0,0,1-1.9-3.3V105.86a4.2,4.2,0,0,1,1.91-3.3L262.43,14a4.24,4.24,0,0,1,3.8,0l3.34,1.93a4.19,4.19,0,0,1,1.91,3.3V266.48a4.19,4.19,0,0,1-1.91,3.3L116.18,358.35A4.26,4.26,0,0,1,112.37,358.35Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,358.35,109,356.42a4.21,4.21,0,0,1-1.9-3.3V105.86a4.2,4.2,0,0,1,1.91-3.3L262.43,14a4.24,4.24,0,0,1,3.8,0l3.34,1.93a4.19,4.19,0,0,1,1.91,3.3V266.48a4.19,4.19,0,0,1-1.91,3.3L116.18,358.35A4.26,4.26,0,0,1,112.37,358.35Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,18.91c-.14-1-.94-1.35-1.89-.79L116.18,106.68a3.85,3.85,0,0,0-1.35,1.42L107.68,104a4,4,0,0,1,1.34-1.41L262.42,14a4.26,4.26,0,0,1,3.81,0l3.34,1.93A4.29,4.29,0,0,1,271.46,18.91Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,18.91c-.14-1-.94-1.35-1.89-.79L116.18,106.68a3.85,3.85,0,0,0-1.35,1.42L107.68,104a4,4,0,0,1,1.34-1.41L262.42,14a4.26,4.26,0,0,1,3.81,0l3.34,1.93A4.29,4.29,0,0,1,271.46,18.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,358.5l-.11,0-.2.07-.08,0-.35.09h0a4.24,4.24,0,0,1-2.27-.19,2.68,2.68,0,0,1-.42-.19L109,356.42a4.23,4.23,0,0,1-1.9-3.3V105.86a4,4,0,0,1,.56-1.89l7.15,4.13a3.85,3.85,0,0,0-.56,1.88V357.25a1.55,1.55,0,0,0,.29,1,1,1,0,0,0,1,.33Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,358.5l-.11,0-.2.07-.08,0-.35.09h0a4.24,4.24,0,0,1-2.27-.19,2.68,2.68,0,0,1-.42-.19L109,356.42a4.23,4.23,0,0,1-1.9-3.3V105.86a4,4,0,0,1,.56-1.89l7.15,4.13a3.85,3.85,0,0,0-.56,1.88V357.25a1.55,1.55,0,0,0,.29,1,1,1,0,0,0,1,.33Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,95.93a1.53,1.53,0,0,0-.34-.7l-.13-.11a.73.73,0,0,0-.71-.1,1.12,1.12,0,0,0-.26.11,3.07,3.07,0,0,0-1.08,1.31,4.77,4.77,0,0,0-.44,1.92,1.86,1.86,0,0,0,.43,1.36.83.83,0,0,0,1.09.09,2.07,2.07,0,0,0,.59-.53,3.48,3.48,0,0,0,.4-.62,4.56,4.56,0,0,0,.53-2A2.82,2.82,0,0,0,169.62,95.93Zm24.94-55.74a3.64,3.64,0,0,0-1.83-.48,7.06,7.06,0,0,0-3.44,1.11A15.49,15.49,0,0,0,183,48.43c-.2.45-.39.91-.56,1.37s-.35.92-.5,1.4-.32,1-.46,1.44c-.05.16-.1.32-.14.47-.1.33-.19.64-.28,1a.5.5,0,0,1,0,.13L180.5,56c-.08.33-.16.64-.25,1l-.24.95c-.34,1.26-.68,2.47-1.07,3.63-.07.24-.15.47-.24.7s-.23.66-.36,1-.2.49-.3.72c-.16.39-.33.76-.5,1.12s-.23.46-.35.68c-2.68,5.16-6,7.18-7.87,9.84-1.66,2.31-2.14,4.17-4.38,7.83-.7,1.17-1.59,2.52-2.77,4.13-3.23,4.46-4.39,6.67-4.79,8a.36.36,0,0,0,0,.11c0,.11-.06.2-.08.3a.29.29,0,0,0,0,.09,1.64,1.64,0,0,1,0,.25,5.77,5.77,0,0,0,0,.79V107l3.57,2.06V99.13A4.63,4.63,0,0,1,161,97.6c.39-1.34,1.54-3.54,4.78-8,1.17-1.62,2.06-3,2.78-4.14,2.23-3.66,2.71-5.51,4.37-7.81,0,0,0,0,0,0,1.9-2.66,5.18-4.67,7.87-9.85a27,27,0,0,0,1.15-2.51c1.72-4.3,2.49-10,4.61-14.8a15.55,15.55,0,0,1,6.34-7.59c2.17-1.25,3.77-1.36,5-.78Zm15.66,12.69h0a4.27,4.27,0,0,0-.95-.37c-1.35-.32-3.36.46-5.38.23,2.83,3.66,6.77,1.31,9,1.83a3.22,3.22,0,0,1,.95.39h0Zm7.55,13.63a2.1,2.1,0,0,0-.3.22l-.14.15a1.07,1.07,0,0,0-.14.16,4.43,4.43,0,0,0-.94,2.69,1.91,1.91,0,0,0,.42,1.35l.12.11a.74.74,0,0,0,.71.1.77.77,0,0,0,.27-.11,3.05,3.05,0,0,0,.32-.22,4,4,0,0,0,.41-.48,4.55,4.55,0,0,0,.79-2.5C219.29,66.68,218.61,66,217.77,66.51Zm2.34-9a11.46,11.46,0,0,0-3.69-1.31c-.54-.12-1-.27-1.47-.4a10.33,10.33,0,0,0,5,2.46,14.26,14.26,0,0,1,3.3,1.07Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,95.93a1.53,1.53,0,0,0-.34-.7l-.13-.11a.73.73,0,0,0-.71-.1,1.12,1.12,0,0,0-.26.11,3.07,3.07,0,0,0-1.08,1.31,4.77,4.77,0,0,0-.44,1.92,1.86,1.86,0,0,0,.43,1.36.83.83,0,0,0,1.09.09,2.07,2.07,0,0,0,.59-.53,3.48,3.48,0,0,0,.4-.62,4.56,4.56,0,0,0,.53-2A2.82,2.82,0,0,0,169.62,95.93Zm24.94-55.74a3.64,3.64,0,0,0-1.83-.48,7.06,7.06,0,0,0-3.44,1.11A15.49,15.49,0,0,0,183,48.43c-.2.45-.39.91-.56,1.37s-.35.92-.5,1.4-.32,1-.46,1.44c-.05.16-.1.32-.14.47-.1.33-.19.64-.28,1a.5.5,0,0,1,0,.13L180.5,56c-.08.33-.16.64-.25,1l-.24.95c-.34,1.26-.68,2.47-1.07,3.63-.07.24-.15.47-.24.7s-.23.66-.36,1-.2.49-.3.72c-.16.39-.33.76-.5,1.12s-.23.46-.35.68c-2.68,5.16-6,7.18-7.87,9.84-1.66,2.31-2.14,4.17-4.38,7.83-.7,1.17-1.59,2.52-2.77,4.13-3.23,4.46-4.39,6.67-4.79,8a.36.36,0,0,0,0,.11c0,.11-.06.2-.08.3a.29.29,0,0,0,0,.09,1.64,1.64,0,0,1,0,.25,5.77,5.77,0,0,0,0,.79V107l3.57,2.06V99.13A4.63,4.63,0,0,1,161,97.6c.39-1.34,1.54-3.54,4.78-8,1.17-1.62,2.06-3,2.78-4.14,2.23-3.66,2.71-5.51,4.37-7.81,0,0,0,0,0,0,1.9-2.66,5.18-4.67,7.87-9.85a27,27,0,0,0,1.15-2.51c1.72-4.3,2.49-10,4.61-14.8a15.55,15.55,0,0,1,6.34-7.59c2.17-1.25,3.77-1.36,5-.78Zm15.66,12.69h0a4.27,4.27,0,0,0-.95-.37c-1.35-.32-3.36.46-5.38.23,2.83,3.66,6.77,1.31,9,1.83a3.22,3.22,0,0,1,.95.39h0Zm7.55,13.63a2.1,2.1,0,0,0-.3.22l-.14.15a1.07,1.07,0,0,0-.14.16,4.43,4.43,0,0,0-.94,2.69,1.91,1.91,0,0,0,.42,1.35l.12.11a.74.74,0,0,0,.71.1.77.77,0,0,0,.27-.11,3.05,3.05,0,0,0,.32-.22,4,4,0,0,0,.41-.48,4.55,4.55,0,0,0,.79-2.5C219.29,66.68,218.61,66,217.77,66.51Zm2.34-9a11.46,11.46,0,0,0-3.69-1.31c-.54-.12-1-.27-1.47-.4a10.33,10.33,0,0,0,5,2.46,14.26,14.26,0,0,1,3.3,1.07Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.56,59.52l-.28-.17a13.79,13.79,0,0,0-3.3-1.07,10.29,10.29,0,0,1-5-2.46,6.43,6.43,0,0,0-1.16-.86,3.33,3.33,0,0,0-1-.39c-2.16-.52-6.1,1.84-8.93-1.83a.94.94,0,0,1-.09-.12c-2-2.66-2.7-8.61-5.67-10.36a2.11,2.11,0,0,0-.3-.16c-1.22-.58-2.81-.47-5,.78-7.86,4.54-8.12,15.31-11,22.39s-6.84,9.31-9,12.36-2.32,5.3-7.16,12-5,8.29-5,9.55v9.92L225,71.93V62A2.5,2.5,0,0,0,223.56,59.52ZM168.18,99.81c-.84.49-1.52-.16-1.52-1.46a4,4,0,0,1,1.52-3.22c.84-.48,1.51.18,1.51,1.47A4,4,0,0,1,168.18,99.81Zm24.68-29.89a3.25,3.25,0,0,1-5-1.52,9.15,9.15,0,0,1-.78-4c0-4.87,2.57-10.3,5.74-12.13a4.69,4.69,0,0,1,1.38-.54c2.5-.5,4.34,1.91,4.34,6.06C198.58,62.66,196,68.09,192.86,69.92Zm24.92,1.25c-.85.49-1.53-.16-1.53-1.45a4,4,0,0,1,1.53-3.21c.83-.48,1.51.17,1.51,1.46A4,4,0,0,1,217.78,71.17Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.56,59.52l-.28-.17a13.79,13.79,0,0,0-3.3-1.07,10.29,10.29,0,0,1-5-2.46,6.43,6.43,0,0,0-1.16-.86,3.33,3.33,0,0,0-1-.39c-2.16-.52-6.1,1.84-8.93-1.83a.94.94,0,0,1-.09-.12c-2-2.66-2.7-8.61-5.67-10.36a2.11,2.11,0,0,0-.3-.16c-1.22-.58-2.81-.47-5,.78-7.86,4.54-8.12,15.31-11,22.39s-6.84,9.31-9,12.36-2.32,5.3-7.16,12-5,8.29-5,9.55v9.92L225,71.93V62A2.5,2.5,0,0,0,223.56,59.52ZM168.18,99.81c-.84.49-1.52-.16-1.52-1.46a4,4,0,0,1,1.52-3.22c.84-.48,1.51.18,1.51,1.47A4,4,0,0,1,168.18,99.81Zm24.68-29.89a3.25,3.25,0,0,1-5-1.52,9.15,9.15,0,0,1-.78-4c0-4.87,2.57-10.3,5.74-12.13a4.69,4.69,0,0,1,1.38-.54c2.5-.5,4.34,1.91,4.34,6.06C198.58,62.66,196,68.09,192.86,69.92Zm24.92,1.25c-.85.49-1.53-.16-1.53-1.45a4,4,0,0,1,1.53-3.21c.83-.48,1.51.17,1.51,1.46A4,4,0,0,1,217.78,71.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,97.6a4.63,4.63,0,0,0-.23,1.53v9.93L157.15,107V97.08a5.77,5.77,0,0,1,0-.79,1.64,1.64,0,0,0,0-.25.29.29,0,0,1,0-.09c0-.1.05-.19.08-.3l0-.11h0Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,77.65c-1.66,2.3-2.14,4.15-4.37,7.81l-3.57-2.06c2.24-3.66,2.72-5.52,4.38-7.83h0Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.52,50.47c-2.12,4.81-2.89,10.5-4.61,14.8a27,27,0,0,1-1.15,2.51l-3.57-2c.12-.22.23-.45.35-.68s.34-.73.5-1.12c.1-.23.21-.47.3-.72s.25-.64.36-1,.17-.46.24-.7c.39-1.16.73-2.37,1.07-3.63l.24-.95c.09-.32.17-.63.25-1l.48-1.79a.5.5,0,0,0,0-.13c.09-.33.18-.64.28-1,0-.15.09-.31.14-.47.14-.48.3-1,.46-1.44s.32-.94.5-1.4.36-.92.56-1.37Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,97.6a4.63,4.63,0,0,0-.23,1.53v9.93L157.15,107V97.08a5.77,5.77,0,0,1,0-.79,1.64,1.64,0,0,0,0-.25.29.29,0,0,1,0-.09c0-.1.05-.19.08-.3l0-.11h0Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,77.65c-1.66,2.3-2.14,4.15-4.37,7.81l-3.57-2.06c2.24-3.66,2.72-5.52,4.38-7.83h0Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.52,50.47c-2.12,4.81-2.89,10.5-4.61,14.8a27,27,0,0,1-1.15,2.51l-3.57-2c.12-.22.23-.45.35-.68s.34-.73.5-1.12c.1-.23.21-.47.3-.72s.25-.64.36-1,.17-.46.24-.7c.39-1.16.73-2.37,1.07-3.63l.24-.95c.09-.32.17-.63.25-1l.48-1.79a.5.5,0,0,0,0-.13c.09-.33.18-.64.28-1,0-.15.09-.31.14-.47.14-.48.3-1,.46-1.44s.32-.94.5-1.4.36-.92.56-1.37Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.1,96.44a4.77,4.77,0,0,0-.44,1.92,1.86,1.86,0,0,0,.43,1.36,1.92,1.92,0,0,1-.43-1.36A4.94,4.94,0,0,1,167.1,96.44Zm2.6.17a2.82,2.82,0,0,0-.08-.68,3.47,3.47,0,0,1,.07.68,4.55,4.55,0,0,1-.52,2A4.56,4.56,0,0,0,169.7,96.61Zm47.09-25.42a.74.74,0,0,0,.71.1A.8.8,0,0,1,216.79,71.19Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.59,57.79c0,4.87-2.57,10.3-5.73,12.13a3.25,3.25,0,0,1-5-1.51,4.52,4.52,0,0,0,1.39-.55C192.46,66,195,60.6,195,55.72a9.13,9.13,0,0,0-.78-4C196.73,51.23,198.59,53.64,198.59,57.79Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.59,57.79c0,4.87-2.57,10.3-5.73,12.13a3.25,3.25,0,0,1-5-1.51,4.52,4.52,0,0,0,1.39-.55C192.46,66,195,60.6,195,55.72a9.13,9.13,0,0,0-.78-4C196.73,51.23,198.59,53.64,198.59,57.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.17,98.66a3.48,3.48,0,0,1-.4.62,2.07,2.07,0,0,1-.59.53.83.83,0,0,1-1.09-.09,1.86,1.86,0,0,1-.43-1.36,4.77,4.77,0,0,1,.44-1.92,3.07,3.07,0,0,1,1.08-1.31,1.12,1.12,0,0,1,.26-.11.79.79,0,0,1,.84.21,1.53,1.53,0,0,1,.34.7,2.82,2.82,0,0,1,.08.68A4.59,4.59,0,0,1,169.17,98.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,68a4.55,4.55,0,0,1-.79,2.5,4,4,0,0,1-.41.48,3.05,3.05,0,0,1-.32.22.77.77,0,0,1-.27.11.75.75,0,0,1-.83-.21,1.91,1.91,0,0,1-.42-1.35,4.43,4.43,0,0,1,.94-2.69,1.07,1.07,0,0,1,.14-.16l.14-.15a2.1,2.1,0,0,1,.3-.22C218.61,66,219.29,66.68,219.29,68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.29,55.13c-.14-.47-.58-.62-1.1-.32L129.7,131.88a2.37,2.37,0,0,0-.81.85l-3.57-2.06a2.33,2.33,0,0,1,.17-.26,2.2,2.2,0,0,1,.2-.23,2,2,0,0,1,.44-.36L259.62,52.75a1.66,1.66,0,0,1,.33-.15,2.58,2.58,0,0,1,1.69,0,1.15,1.15,0,0,1,.25.12l1.3.74a1.33,1.33,0,0,1,.19.14.7.7,0,0,1,.16.14,2.23,2.23,0,0,1,.21.22,1.43,1.43,0,0,1,.14.2,1.64,1.64,0,0,1,.14.22,2.55,2.55,0,0,1,.2.48A2.1,2.1,0,0,1,264.29,55.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,383l-92.35-49.35h0l-12.58-8.15a147.29,147.29,0,0,1-28.29-23.89,167.65,167.65,0,0,1-44.24-113.47v-49l-4.07-2.34-131.7-2.91a2.44,2.44,0,0,1,.33-1.13l-3.57-2.06a2.44,2.44,0,0,0-.14.28,2.18,2.18,0,0,0-.19.85v83.33h0l-.06,0v49c0,2.33,0,4.67.07,7v.08a138.25,138.25,0,0,0,1.37,17.88q.89,5.91,2.2,11.72a167.73,167.73,0,0,0,40.17,76.81A147,147,0,0,0,197,401.56l12.58,8.15,91.46,52.8.05,0,4,2.32a4.79,4.79,0,0,0,4.33,0L440.9,389a1.5,1.5,0,0,0,.89-1.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,383v4.7a1.49,1.49,0,0,1-.89,1.25L309.46,464.85a4.41,4.41,0,0,1-2.17.52v-4.7a4.38,4.38,0,0,0,2.17-.52L440.9,384.27A1.52,1.52,0,0,0,441.79,383Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.9,381.77,349.44,329h0l-12.58-8.15a147.29,147.29,0,0,1-28.29-23.89,167.65,167.65,0,0,1-44.24-113.47v-128a1.37,1.37,0,0,0,0-.34c-.14-.47-.58-.62-1.1-.32L129.7,131.88a2.37,2.37,0,0,0-.81.85,2.44,2.44,0,0,0-.33,1.13v128A167.73,167.73,0,0,0,172.8,375.31a147,147,0,0,0,28.29,23.89l12.58,8.15,91.46,52.8a4.79,4.79,0,0,0,4.33,0L440.9,384.27A1.32,1.32,0,0,0,440.9,381.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,83l-.19.29a6.85,6.85,0,0,0-.9,2.26c0,.06,0,.1,0,.12a.18.18,0,0,0,0,.05L178.88,98l-.69,3.92a3.89,3.89,0,0,1-.12.49,2.79,2.79,0,0,1-.14.47,3,3,0,0,0-.11.32l3.56,2.06a6.39,6.39,0,0,0,.38-1.27l.69-3.92,2.16-12.26a6.71,6.71,0,0,1,1.12-2.74Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,122.59c-.36.56-.71,1.14-1,1.71-.16.28-.3.56-.43.83s-.35.72-.5,1.08-.34.8-.49,1.2-.3.8-.43,1.21-.31.94-.44,1.42c-.09.31-.17.62-.26,1-.2.75-.37,1.52-.53,2.29-.06.27-.12.55-.17.81s-.13.65-.19,1c0,0,0,0,0,.05,0,.26,0,.43.13.5a.14.14,0,0,0,.11,0h0l3-2.41.5-.4.24-.18.27-.21.21-.16a1.16,1.16,0,0,1,.18-.14,27.29,27.29,0,0,1,4.41-9L158.68,121C158.29,121.56,157.92,122.07,157.59,122.59Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.2,56.07c-.16.27-.31.54-.45.82a3.2,3.2,0,0,0-.26.48c-.13.23-.24.46-.36.69s-.19.37-.27.56c-.18.37-.34.73-.49,1.09s-.34.79-.49,1.18a0,0,0,0,0,0,0c-.14.35-.27.71-.38,1.06-.19.53-.35,1.07-.5,1.61-.08.28-.15.56-.22.84l0,.06-.09.43c-.08.34-.15.67-.2,1s-.11.53-.18.79-.14.55-.23.83-.17.52-.25.79c0,0,0,0,0,.07-.11.28-.22.58-.35.88s-.24.59-.38.89a2.08,2.08,0,0,0-.1.24l-.33.68c-.18.37-.37.74-.56,1.1s-.26.49-.4.73L193.23,75A24.05,24.05,0,0,0,196,68a30.78,30.78,0,0,1,3.76-9.86Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.44,64a1.29,1.29,0,0,0-.58-.2,4.36,4.36,0,0,0,3.19,2,2.22,2.22,0,0,1,.89.19Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.44,64a1.29,1.29,0,0,0-.58-.2,4.36,4.36,0,0,0,3.19,2,2.22,2.22,0,0,1,.89.19Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71,79.53a3.87,3.87,0,0,0-3.58.1c-4.15,1.84-5.95,2.66-8.09,3.56-.42,2.75,1.21,3,2,2.69,3-1.2,4.55-1.93,9.65-4.17a3.85,3.85,0,0,1,3.55-.12Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71,79.53a3.87,3.87,0,0,0-3.58.1c-4.15,1.84-5.95,2.66-8.09,3.56-.42,2.75,1.21,3,2,2.69,3-1.2,4.55-1.93,9.65-4.17a3.85,3.85,0,0,1,3.55-.12Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,105.28a14.62,14.62,0,0,1-3.14,4.49l-11.19,8.39a30,30,0,0,0-4.8,5L158.68,121a29.49,29.49,0,0,1,4.8-4.94l11.2-8.4a14.85,14.85,0,0,0,3.14-4.48Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,105.28a14.62,14.62,0,0,1-3.14,4.49l-11.19,8.39a30,30,0,0,0-4.8,5L158.68,121a29.49,29.49,0,0,1,4.8-4.94l11.2-8.4a14.85,14.85,0,0,0,3.14-4.48Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,75a37.77,37.77,0,0,1-5.64,7.87,13.34,13.34,0,0,0-1.86,2.24l-3.56-2A12.35,12.35,0,0,1,184,80.78a37.57,37.57,0,0,0,5.64-7.86Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,75a37.77,37.77,0,0,1-5.64,7.87,13.34,13.34,0,0,0-1.86,2.24l-3.56-2A12.35,12.35,0,0,1,184,80.78a37.57,37.57,0,0,0,5.64-7.86Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,48.61c-1.32-.69-3.07-.57-5.14.51-3.06,1.6-6.14,5-8.48,9l-3.58-2.06c2.35-4,5.43-7.41,8.5-9a7.14,7.14,0,0,1,3.27-.93,4.06,4.06,0,0,1,2,.5Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,48.61c-1.32-.69-3.07-.57-5.14.51-3.06,1.6-6.14,5-8.48,9l-3.58-2.06c2.35-4,5.43-7.41,8.5-9a7.14,7.14,0,0,1,3.27-.93,4.06,4.06,0,0,1,2,.5Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,123.11a27.29,27.29,0,0,0-4.41,9,1.16,1.16,0,0,0-.18.14l-.21.16-.27.21-.24.18-.5.4-3,2.41h0a.14.14,0,0,1-.11,0c-.12-.07-.17-.24-.13-.5,0,0,0,0,0-.05.06-.33.13-.65.19-1s.11-.54.17-.81c.16-.77.33-1.54.53-2.29.09-.33.17-.64.26-1,.13-.48.28-.95.44-1.42s.28-.81.43-1.21.32-.8.49-1.2.32-.72.5-1.08.27-.55.43-.83c.3-.57.65-1.15,1-1.71s.7-1,1.09-1.55Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.73,85.09a6.71,6.71,0,0,0-1.12,2.74l-2.16,12.26-.69,3.92a6.39,6.39,0,0,1-.38,1.27l-3.56-2.06a3,3,0,0,1,.11-.32,2.79,2.79,0,0,0,.14-.47,3.89,3.89,0,0,0,.12-.49l.69-3.92,2.17-12.26a.18.18,0,0,1,0-.05s0-.06,0-.12a6.85,6.85,0,0,1,.9-2.26l.19-.29Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.78,58.13A30.78,30.78,0,0,0,196,68a24.05,24.05,0,0,1-2.79,7l-3.58-2.06c.14-.24.27-.48.4-.73s.38-.73.56-1.1l.33-.68a2.08,2.08,0,0,1,.1-.24c.13-.29.26-.6.38-.89s.24-.6.35-.88c0,0,0-.05,0-.07.08-.27.18-.53.25-.79s.17-.56.23-.83.13-.53.18-.79.12-.66.2-1l.09-.43,0-.06c.07-.28.14-.56.22-.84.15-.54.31-1.08.5-1.61.11-.35.24-.71.38-1.06a0,0,0,0,1,0,0c.15-.39.32-.79.49-1.18s.31-.72.49-1.09c.08-.19.18-.37.27-.56s.23-.46.36-.69a3.2,3.2,0,0,1,.26-.48c.14-.28.29-.55.45-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,135.62h0l3-2.41C155.2,134.16,153.55,135.45,153.38,135.62Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.31,81.62l-.05,0a3.9,3.9,0,0,0-3.56.11c-5.09,2.25-6.63,3-9.64,4.18-.81.33-2.44.06-2-2.69a1.48,1.48,0,0,1,0-.19l.69-3.92,1.93-10.68s.44-1.68-.68-2.32c0,0,0,0-.08,0a2,2,0,0,0-.89-.2,4.32,4.32,0,0,1-3.18-2,8.06,8.06,0,0,1-1.2-6.11c.81-4.58-.08-7.79-2.11-9l-.16-.1c-1.31-.69-3.07-.58-5.12.5C202.84,52,197.36,60.41,196,68c-.84,4.79-5.65,12.15-8.43,14.86s-3,5-3,5l-2.16,12.27-.69,3.92c-.51,2.93-3.52,5.76-3.52,5.76l-11.19,8.39a27,27,0,0,0-9.21,13.94s-4.2,3.26-4.46,3.52h0l1.43-.82,77.26-44.41,1.08-.6c.19-.12,3.3-3.06,3.3-3.06C236.34,84.19,235.6,82.39,234.31,81.62ZM212,59.08c-.83,4.66-4.19,9.86-7.53,11.61-2.31,1.21-4,.46-4.55-1.66a8.89,8.89,0,0,1,0-3.62c.83-4.66,4.2-9.86,7.54-11.6a5.61,5.61,0,0,1,1-.41C211.16,52.56,212.73,54.89,212,59.08Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.31,81.62l-.05,0a3.9,3.9,0,0,0-3.56.11c-5.09,2.25-6.63,3-9.64,4.18-.81.33-2.44.06-2-2.69a1.48,1.48,0,0,1,0-.19l.69-3.92,1.93-10.68s.44-1.68-.68-2.32c0,0,0,0-.08,0a2,2,0,0,0-.89-.2,4.32,4.32,0,0,1-3.18-2,8.06,8.06,0,0,1-1.2-6.11c.81-4.58-.08-7.79-2.11-9l-.16-.1c-1.31-.69-3.07-.58-5.12.5C202.84,52,197.36,60.41,196,68c-.84,4.79-5.65,12.15-8.43,14.86s-3,5-3,5l-2.16,12.27-.69,3.92c-.51,2.93-3.52,5.76-3.52,5.76l-11.19,8.39a27,27,0,0,0-9.21,13.94s-4.2,3.26-4.46,3.52h0l1.43-.82,77.26-44.41,1.08-.6c.19-.12,3.3-3.06,3.3-3.06C236.34,84.19,235.6,82.39,234.31,81.62ZM212,59.08c-.83,4.66-4.19,9.86-7.53,11.61-2.31,1.21-4,.46-4.55-1.66a8.89,8.89,0,0,1,0-3.62c.83-4.66,4.2-9.86,7.54-11.6a5.61,5.61,0,0,1,1-.41C211.16,52.56,212.73,54.89,212,59.08Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.39,135.63l78.69-45.24,1.09-.6c.19-.12,3.3-3.07,3.3-3.07L157.84,132.1S153.08,135.79,153.39,135.63Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,53.4a5.61,5.61,0,0,0-1,.41c-3.34,1.74-6.71,6.94-7.54,11.6a8.89,8.89,0,0,0,0,3.62c.56,2.12,2.24,2.87,4.55,1.66,3.34-1.75,6.7-6.95,7.53-11.61C212.73,54.89,211.16,52.56,208.41,53.4Zm-8.3,15.54a8.69,8.69,0,0,1,0-3.49c.81-4.6,4.15-9.74,7.42-11.44a5.65,5.65,0,0,1,.91-.39,9,9,0,0,1,0,3.39c-.82,4.67-4.19,9.86-7.53,11.61a6.74,6.74,0,0,1-.76.33Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,53.4a5.61,5.61,0,0,0-1,.41c-3.34,1.74-6.71,6.94-7.54,11.6a8.89,8.89,0,0,0,0,3.62c.56,2.12,2.24,2.87,4.55,1.66,3.34-1.75,6.7-6.95,7.53-11.61C212.73,54.89,211.16,52.56,208.41,53.4Zm-8.3,15.54a8.69,8.69,0,0,1,0-3.49c.81-4.6,4.15-9.74,7.42-11.44a5.65,5.65,0,0,1,.91-.39,9,9,0,0,1,0,3.39c-.82,4.67-4.19,9.86-7.53,11.61a6.74,6.74,0,0,1-.76.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71,179.08v50.81c0,.91.63,1.28,1.42.82l75.56-43.52a3.16,3.16,0,0,0,1.43-2.47V133.91c0-.92-.64-1.28-1.43-.83L138.13,176.6A3.16,3.16,0,0,0,136.71,179.08Z",
    style: {
      fill: "#416259",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,225.85s6.83-9,8.82-12.82c2.95-5.71,2.27-16.76,7.92-20s4.76,11.34,12.07,7.16,7.3-9.13,11-11.55,6.93,2.42,11.29,0c5-2.78,7.29-19.79,12.45-22.62,5.78-3.17,8.07,12.32,8.07,12.32v6.19Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,225.85s3.21-17.3,6.7-19.33c5-2.9,3.24,10,10,5.8,5.55-3.39,4.52-18.11,11.72-22.16,5.41-3,5.06,8.53,11.71,4.77s5-22.33,11.71-26.08,5.78,16.13,10.92,13c6.07-3.65,4-8.56,8.83-12.85V184.5Z",
    style: {
      fill: "#416259",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,225.85s3.21-17.3,6.7-19.33c5-2.9,3.24,10,10,5.8,5.55-3.39,4.52-18.11,11.72-22.16,5.41-3,5.06,8.53,11.71,4.77s5-22.33,11.71-26.08,5.78,16.13,10.92,13c6.07-3.65,4-8.56,8.83-12.85V184.5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,181.94c0,1.07.75,1.5,1.67,1a3.69,3.69,0,0,0,1.67-2.9c0-1.07-.74-1.5-1.67-1A3.71,3.71,0,0,0,143.39,181.94Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,181.94c0,1.07.75,1.5,1.67,1a3.69,3.69,0,0,0,1.67-2.9c0-1.07-.74-1.5-1.67-1A3.71,3.71,0,0,0,143.39,181.94Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,176.8l28.39-16.39c.48-.27.87-.07.87.47a1.87,1.87,0,0,1-.87,1.46L151,178.74c-.48.27-.87.06-.87-.47A1.9,1.9,0,0,1,151,176.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,189.67c0,1.07.75,1.5,1.67,1a3.69,3.69,0,0,0,1.67-2.9c0-1.07-.74-1.5-1.67-1A3.71,3.71,0,0,0,143.39,189.67Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,184.53l28.39-16.39c.48-.27.87-.07.87.47a1.87,1.87,0,0,1-.87,1.46L151,186.47c-.48.27-.87.06-.87-.47A1.9,1.9,0,0,1,151,184.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,239.07v33.6c0,.6.43.85.95.55L177.81,250a2.08,2.08,0,0,0,.94-1.63V214.78c0-.6-.42-.84-.94-.54l-40.17,23.19A2.09,2.09,0,0,0,136.69,239.07Z",
    style: {
      fill: "#416259",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 266.1 141.12 240.54 142.65 239.66 142.65 265.22 141.12 266.1",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.78 268.07 142.99 266.79 142.99 267.58 140.78 268.85 140.78 268.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.02 264.42 144.02 243.97 145.55 243.09 145.55 263.54 144.02 264.42",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.68 266.39 145.89 265.12 145.89 265.9 143.68 267.18 143.68 266.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.45 261.87 148.45 239.65 149.98 238.78 149.98 260.99 148.45 261.87",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.11 263.83 150.33 262.55 150.33 263.33 148.11 264.61 148.11 263.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.35 260.19 151.35 241.81 152.88 240.93 152.88 259.31 151.35 260.19",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.02 262.15 153.23 260.87 153.23 261.66 151.02 262.94 151.02 262.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.78 257.64 155.78 247.39 157.31 246.51 157.31 256.76 155.78 257.64",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.43 259.61 157.65 258.33 157.65 259.11 155.43 260.39 155.43 259.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.69 255.96 158.69 244.33 160.21 243.45 160.21 255.08 158.69 255.96",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.34 257.93 160.55 256.65 160.55 257.43 158.34 258.71 158.34 257.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.11 253.4 163.11 239.38 164.64 238.5 164.64 252.52 163.11 253.4",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.79 255.37 165 254.09 165 254.87 162.79 256.15 162.79 255.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.02 251.72 166.02 242.6 167.54 241.72 167.54 250.85 166.02 251.72",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.69 253.69 167.91 252.41 167.91 253.19 165.69 254.47 165.69 253.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.44 249.17 170.44 245.18 171.97 244.31 171.97 248.29 170.44 249.17",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 266.1 141.12 240.54 142.65 239.66 142.65 265.22 141.12 266.1",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.45 261.87 148.45 239.65 149.98 238.78 149.98 260.99 148.45 261.87",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.78 257.64 155.78 247.39 157.31 246.51 157.31 256.76 155.78 257.64",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.11 253.4 163.11 239.38 164.64 238.5 164.64 252.52 163.11 253.4",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.44 249.17 170.44 245.18 171.97 244.31 171.97 248.29 170.44 249.17",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.12 251.13 172.34 249.85 172.34 250.63 170.12 251.91 170.12 251.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.35 247.49 173.35 245.51 174.87 244.63 174.87 246.62 173.35 247.49",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.03 249.45 175.24 248.17 175.24 248.96 173.02 250.23 173.03 249.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 226.85 161.6 227.81 161.6 229.73 163.26 228.77 163.26 226.85",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 226.85 161.6 227.81 161.6 229.73 163.26 228.77 163.26 226.85",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11,219.71l-11.87,6.84a1,1,0,0,0-.43.75v.38c0,.27.19.39.43.25l11.87-6.85a1,1,0,0,0,.43-.75V220C176.54,219.68,176.35,219.57,176.11,219.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 230.05 161.6 231.01 161.6 232.93 163.26 231.97 163.26 230.05",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11,222.9l-11.87,6.85a1,1,0,0,0-.43.75v.37c0,.28.19.39.43.25l11.87-6.85a.93.93,0,0,0,.43-.75v-.37C176.54,222.88,176.35,222.76,176.11,222.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 266.1 141.12 240.54 142.65 239.66 142.65 265.22 141.12 266.1",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.45 261.87 148.45 239.65 149.98 238.78 149.98 260.99 148.45 261.87",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.78 257.64 155.78 247.39 157.31 246.51 157.31 256.76 155.78 257.64",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.11 253.4 163.11 239.38 164.64 238.5 164.64 252.52 163.11 253.4",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 266.1 141.12 240.54 142.65 239.66 142.65 265.22 141.12 266.1",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.45 261.87 148.45 239.65 149.98 238.78 149.98 260.99 148.45 261.87",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.78 257.64 155.78 247.39 157.31 246.51 157.31 256.76 155.78 257.64",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.11 253.4 163.11 239.38 164.64 238.5 164.64 252.52 163.11 253.4",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.44 249.17 170.44 245.18 171.97 244.31 171.97 248.29 170.44 249.17",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 266.1 141.12 240.54 142.65 239.66 142.65 265.22 141.12 266.1",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.45 261.87 148.45 239.65 149.98 238.78 149.98 260.99 148.45 261.87",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.78 257.64 155.78 247.39 157.31 246.51 157.31 256.76 155.78 257.64",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.11 253.4 163.11 239.38 164.64 238.5 164.64 252.52 163.11 253.4",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.44 249.17 170.44 245.18 171.97 244.31 171.97 248.29 170.44 249.17",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.18,212.26v33.61c0,.6.42.84.95.54l30-17.35a2.09,2.09,0,0,0,1-1.63V193.82c0-.6-.43-.84-1-.54l-30,17.35A2.06,2.06,0,0,0,183.18,212.26Z",
    style: {
      fill: "#416259",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.06 211.49 185.4 212.45 185.4 214.37 187.06 213.41 187.06 211.49",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.18,208.45l-5.48,3.16a.57.57,0,0,0-.26.45v.52c0,.17.12.23.26.15l5.48-3.16a.59.59,0,0,0,.26-.45v-.52C193.44,208.43,193.32,208.37,193.18,208.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 206.06 194.8 207.02 194.81 208.93 196.46 207.97 196.46 206.06",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 206.06 194.8 207.02 194.81 208.93 196.46 207.97 196.46 206.06",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.62,203.06l-5.48,3.16a.61.61,0,0,0-.26.45v.53a.16.16,0,0,0,.26.15l5.48-3.16a.58.58,0,0,0,.26-.46v-.52C202.88,203.05,202.77,203,202.62,203.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.87 200.62 204.21 201.58 204.21 203.5 205.87 202.54 205.87 200.62",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.87 200.62 204.21 201.58 204.21 203.5 205.87 202.54 205.87 200.62",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.06,197.68l-5.48,3.16a.54.54,0,0,0-.25.45v.52c0,.17.11.23.26.15l5.47-3.16a.55.55,0,0,0,.26-.45v-.52C212.32,197.66,212.21,197.6,212.06,197.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,212c-4.89,2.82-8.86,9.69-8.86,15.33s4,7.94,8.86,5.12,8.85-9.69,8.85-15.34S204.57,209.14,199.68,212Zm-1.37,18.09a5.32,5.32,0,0,1-2.59.84c-1.89,0-2.17-2.25-2.17-3.6,0-4.69,3.43-10.63,7.49-13a5.31,5.31,0,0,1,2.59-.85c1.89,0,2.18,2.26,2.18,3.6C205.81,221.77,202.38,227.71,198.31,230.06Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,214.33a5.31,5.31,0,0,1,2.59-.85c1.18,0,1.73.87,2,1.86l2-2.29c-1.45-2.51-4.45-3.08-7.91-1.08v3.3A9.19,9.19,0,0,1,201,214.33Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,213.05l-2,2.29a6.84,6.84,0,0,1,.2,1.74,10.5,10.5,0,0,1-.14,1.65l2.86-1.65a8,8,0,0,0-.94-4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,135.21c.17-.1.3-.1.39,0a.8.8,0,0,1,.19.32L173,146.27a1.14,1.14,0,0,1,.05.26.85.85,0,0,1-.08.35.49.49,0,0,1-.2.24l-1.6.93c-.17.1-.29.11-.37,0a.47.47,0,0,1-.13-.24l-.36-1.42-3.38,1.95-.36,1.83a1.23,1.23,0,0,1-.13.4.87.87,0,0,1-.36.38l-1.61.92a.14.14,0,0,1-.19,0,.33.33,0,0,1-.09-.26,2.12,2.12,0,0,1,.05-.32L167,137.38a2.14,2.14,0,0,1,.18-.54.94.94,0,0,1,.39-.44ZM167.59,145l2.06-1.19-1-4.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,143a.29.29,0,0,1-.35,0,.55.55,0,0,1-.17-.18l-2.91-5v6.62a1,1,0,0,1-.11.43.62.62,0,0,1-.24.3l-1.66,1a.19.19,0,0,1-.25,0,.4.4,0,0,1-.1-.31V133.18a1,1,0,0,1,.1-.43.69.69,0,0,1,.25-.3l1.32-.76a.33.33,0,0,1,.35,0,.67.67,0,0,1,.17.18l2.91,5v-6.63a1,1,0,0,1,.11-.43.55.55,0,0,1,.24-.29l1.66-1a.21.21,0,0,1,.25,0,.46.46,0,0,1,.1.31v12.66a1.08,1.08,0,0,1-.1.43.59.59,0,0,1-.25.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,124.6c.17-.1.3-.1.39,0a.67.67,0,0,1,.18.33l2.78,10.74a1.14,1.14,0,0,1,.05.26.73.73,0,0,1-.09.35.48.48,0,0,1-.19.24l-1.61.93c-.17.1-.29.11-.36,0a.41.41,0,0,1-.13-.24l-.36-1.42-3.38,2L185,139.6a1.54,1.54,0,0,1-.13.4.9.9,0,0,1-.37.38l-1.6.92a.15.15,0,0,1-.2,0,.36.36,0,0,1-.08-.25,2,2,0,0,1,.05-.33l2.77-13.94a2.7,2.7,0,0,1,.19-.54.94.94,0,0,1,.39-.44ZM186,134.35l2.06-1.19-1-4.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.69,129c.1-.05.18-.05.24,0a.42.42,0,0,1,.11.31v2.08a1,1,0,0,1-.11.43.57.57,0,0,1-.24.3l-5.89,3.4a.18.18,0,0,1-.24,0,.4.4,0,0,1-.1-.31V122.57a1,1,0,0,1,.1-.43.76.76,0,0,1,.24-.3l1.67-1a.18.18,0,0,1,.24,0,.4.4,0,0,1,.1.31v10Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,128.83a1,1,0,0,1-.1.43.76.76,0,0,1-.24.3l-1.67,1a.18.18,0,0,1-.24,0,.4.4,0,0,1-.1-.31V126l-2.94-6.62a.48.48,0,0,1-.05-.23.74.74,0,0,1,.08-.35.45.45,0,0,1,.2-.24l1.74-1c.17-.1.3-.11.38,0a.44.44,0,0,1,.15.2l1.61,3.9,1.61-5.76a2.46,2.46,0,0,1,.16-.38.91.91,0,0,1,.38-.42l1.74-1a.15.15,0,0,1,.2,0,.37.37,0,0,1,.08.26.79.79,0,0,1-.05.28l-2.94,10Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.59,111.38a3.24,3.24,0,0,1,1.5-.5,2.11,2.11,0,0,1,1.17.25,1.88,1.88,0,0,1,.78.8,2.48,2.48,0,0,1,.29,1.15.77.77,0,0,1-.08.35.57.57,0,0,1-.18.23l-1.67,1a.5.5,0,0,1-.29.09.5.5,0,0,1-.22-.11.66.66,0,0,1-.12-.12.7.7,0,0,0-.24-.15.77.77,0,0,0-.38,0,1.35,1.35,0,0,0-.56.21,3.46,3.46,0,0,0-.46.32,3.64,3.64,0,0,0-.4.38,2,2,0,0,0-.28.47,1.42,1.42,0,0,0-.11.55.54.54,0,0,0,.13.42.51.51,0,0,0,.4.13,3.23,3.23,0,0,0,.76-.12l1.17-.3a4.09,4.09,0,0,1,1.22-.16,1.54,1.54,0,0,1,.87.33,1.78,1.78,0,0,1,.53.88,5.53,5.53,0,0,1,.17,1.5,6.5,6.5,0,0,1-.3,2,7.36,7.36,0,0,1-.82,1.81,8.23,8.23,0,0,1-1.24,1.58,7.94,7.94,0,0,1-1.58,1.2,3.71,3.71,0,0,1-1.57.55,2.11,2.11,0,0,1-1.23-.22A2,2,0,0,1,207,125a2.93,2.93,0,0,1-.31-1.3.79.79,0,0,1,.09-.35.56.56,0,0,1,.18-.23l1.67-1a.59.59,0,0,1,.28-.1.4.4,0,0,1,.2.09,1.42,1.42,0,0,1,.16.17.83.83,0,0,0,.27.2.81.81,0,0,0,.43.08,1.46,1.46,0,0,0,.64-.24,4.89,4.89,0,0,0,1.13-.87,1.58,1.58,0,0,0,.45-1.08.41.41,0,0,0-.16-.39.89.89,0,0,0-.5-.08,4.43,4.43,0,0,0-.84.17l-1.22.31a1.87,1.87,0,0,1-1.92-.34,3.5,3.5,0,0,1-.6-2.34,6.43,6.43,0,0,1,.25-1.75,7.48,7.48,0,0,1,.72-1.77,8,8,0,0,1,1.14-1.59A6.1,6.1,0,0,1,210.59,111.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,122.05a.18.18,0,0,1-.24,0,.4.4,0,0,1-.1-.31V109.06a1,1,0,0,1,.1-.43.69.69,0,0,1,.24-.3l1.67-1a.18.18,0,0,1,.24,0,.4.4,0,0,1,.1.31v12.66a1,1,0,0,1-.1.43.65.65,0,0,1-.24.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.31,104a3.24,3.24,0,0,1,1.49-.5,2.14,2.14,0,0,1,1.18.25,1.86,1.86,0,0,1,.77.8,2.49,2.49,0,0,1,.3,1.15.79.79,0,0,1-.09.35.44.44,0,0,1-.18.23l-1.67,1a.47.47,0,0,1-.28.09.49.49,0,0,1-.23-.11l-.12-.12a.57.57,0,0,0-.23-.15.81.81,0,0,0-.39,0,1.27,1.27,0,0,0-.55.21,3,3,0,0,0-.47.32,2.82,2.82,0,0,0-.39.38,1.72,1.72,0,0,0-.28.47,1.26,1.26,0,0,0-.11.55.59.59,0,0,0,.12.42.53.53,0,0,0,.41.13,3.16,3.16,0,0,0,.75-.12q.48-.1,1.17-.3a4.13,4.13,0,0,1,1.22-.16,1.6,1.6,0,0,1,.88.33,1.84,1.84,0,0,1,.52.88,5.53,5.53,0,0,1,.17,1.5,6.82,6.82,0,0,1-.29,2,8.19,8.19,0,0,1-.82,1.81,8.69,8.69,0,0,1-1.25,1.58,7.88,7.88,0,0,1-1.57,1.2,3.74,3.74,0,0,1-1.58.55,2.14,2.14,0,0,1-1.23-.22,2,2,0,0,1-.81-.83,2.93,2.93,0,0,1-.3-1.3.93.93,0,0,1,.08-.35.57.57,0,0,1,.19-.23l1.66-1a.59.59,0,0,1,.28-.1.48.48,0,0,1,.21.09l.15.17a1,1,0,0,0,.27.2.85.85,0,0,0,.44.08,1.55,1.55,0,0,0,.64-.24,4.83,4.83,0,0,0,1.12-.87A1.59,1.59,0,0,0,225,113a.42.42,0,0,0-.17-.39.89.89,0,0,0-.5-.08,4.43,4.43,0,0,0-.84.17l-1.22.31a1.85,1.85,0,0,1-1.91-.34,3.44,3.44,0,0,1-.61-2.34,6.84,6.84,0,0,1,.25-1.75,8.43,8.43,0,0,1,.72-1.77,8,8,0,0,1,1.14-1.59A6.19,6.19,0,0,1,223.31,104Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24,271.29l82.7-47.74a1.65,1.65,0,0,1,2.61,1.21l.19,1.06a3.8,3.8,0,0,1-1.71,3.71l-82.58,47.68a1.7,1.7,0,0,1-2.67-1.2l-.2-1A3.69,3.69,0,0,1,157.24,271.29Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.28,317.58,232.07,279a1.67,1.67,0,0,1,2.39.35,2,2,0,0,1-1.08,2.35l-66.89,38.62c-1,.55-2,.39-2.34-.38A2.05,2.05,0,0,1,165.28,317.58Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.28,317.58,232.07,279a1.67,1.67,0,0,1,2.39.35,2,2,0,0,1-1.08,2.35l-66.89,38.62c-1,.55-2,.39-2.34-.38A2.05,2.05,0,0,1,165.28,317.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,323l40.91-23.59a1.64,1.64,0,0,1,2.38.35,2,2,0,0,1-1.07,2.35l-41,23.65c-1,.55-2,.38-2.34-.38A2.06,2.06,0,0,1,168,323Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.82,343.93,247.2,305a2,2,0,0,1,2.6.23c.49.68.1,1.68-.86,2.23l-67.43,38.93a2,2,0,0,1-2.58-.25C178.47,345.49,178.86,344.49,179.82,343.93Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.82,343.93,247.2,305a2,2,0,0,1,2.6.23c.49.68.1,1.68-.86,2.23l-67.43,38.93a2,2,0,0,1-2.58-.25C178.47,345.49,178.86,344.49,179.82,343.93Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.25,348.88l26.47-15.28a2,2,0,0,1,2.61.22c.48.67.1,1.66-.86,2.22L185,351.3a2.06,2.06,0,0,1-2.62-.21C181.92,350.42,182.29,349.43,183.25,348.88Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,356.06l67.52-39a2.21,2.21,0,0,1,2.7.18c.53.65.19,1.63-.76,2.18l-67.53,39a2.21,2.21,0,0,1-2.7-.17C187.43,357.58,187.77,356.61,188.73,356.06Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,356.06l67.52-39a2.21,2.21,0,0,1,2.7.18c.53.65.19,1.63-.76,2.18l-67.53,39a2.21,2.21,0,0,1-2.7-.17C187.43,357.58,187.77,356.61,188.73,356.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,360.68l26.32-15.2a2.3,2.3,0,0,1,2.75.17c.56.65.24,1.62-.71,2.17L194.67,363a2.33,2.33,0,0,1-2.77-.16C191.33,362.2,191.65,361.23,192.6,360.68Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,331.05l52.84-30.51a1.84,1.84,0,0,1,2.5.29,1.78,1.78,0,0,1-1,2.29l-52.92,30.56a1.77,1.77,0,0,1-2.46-.31A1.85,1.85,0,0,1,172,331.05Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,331.05l52.84-30.51a1.84,1.84,0,0,1,2.5.29,1.78,1.78,0,0,1-1,2.29l-52.92,30.56a1.77,1.77,0,0,1-2.46-.31A1.85,1.85,0,0,1,172,331.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,336.3l48.18-27.82a1.87,1.87,0,0,1,2.53.28c.45.7,0,1.72-.93,2.28l-48.23,27.82a1.85,1.85,0,0,1-2.51-.28A1.76,1.76,0,0,1,175,336.3Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.81,278.32a2.11,2.11,0,0,1,2.86.95,2.19,2.19,0,0,1-.66,3,2.12,2.12,0,0,1-2.87-.95A2.19,2.19,0,0,1,252.81,278.32Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,298.68a2.48,2.48,0,0,1,3.11.8,1.79,1.79,0,0,1-.46,2.77,2.54,2.54,0,0,1-3.11-.8A1.84,1.84,0,0,1,265.67,298.68Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,298.68a2.48,2.48,0,0,1,3.11.8,1.79,1.79,0,0,1-.46,2.77,2.54,2.54,0,0,1-3.11-.8A1.84,1.84,0,0,1,265.67,298.68Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.58,388,317,330a6.12,6.12,0,0,1,5.5,0l53.14,30.68c1.51.88,1.51,2.3,0,3.17l-100.42,58a6.06,6.06,0,0,1-5.5,0l-53.13-30.67C215.06,390.29,215.06,388.87,216.58,388Z",
    style: {
      fill: "#416259",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.55,406.27a.83.83,0,0,1,.18.13.53.53,0,0,1,.12.14.44.44,0,0,1,.06.16.67.67,0,0,1,0,.2l-.05.46.75-.44h.09l.08,0,.37.21s0,0,0,.05,0,0,0,.05l-1.59.92-.09,0a.32.32,0,0,1-.09,0l-.29-.17a.24.24,0,0,1-.09-.08.08.08,0,0,1,0-.09l.16-.94a.24.24,0,0,0,0-.18.52.52,0,0,0-.11-.1l-.08,0-.12,0h-.15a.58.58,0,0,0-.17.06.24.24,0,0,0-.1.1.14.14,0,0,0,0,.09l.05.07,0,0s0,.05,0,.06a.1.1,0,0,1-.06.05l-.37.22H283l-.07,0a.78.78,0,0,1-.24-.2.43.43,0,0,1,0-.5.88.88,0,0,1,.3-.25,1.59,1.59,0,0,1,.41-.16,1.64,1.64,0,0,1,.44,0,1.4,1.4,0,0,1,.41.06A1.42,1.42,0,0,1,284.55,406.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,405.1a2,2,0,0,1,.46-.18,1.94,1.94,0,0,1,.48,0,1.48,1.48,0,0,1,.46.08,2.17,2.17,0,0,1,.42.17,2.48,2.48,0,0,1,.31.18l.3.18a1.22,1.22,0,0,1,.3.24.48.48,0,0,1,.14.26.41.41,0,0,1-.06.28.83.83,0,0,1-.31.26,1.43,1.43,0,0,1-.47.18,1.5,1.5,0,0,1-.47,0,1.77,1.77,0,0,1-.46-.08,2.63,2.63,0,0,1-.42-.17l-.31-.17-.31-.19a1,1,0,0,1-.29-.24.61.61,0,0,1-.15-.27.39.39,0,0,1,.07-.27A1,1,0,0,1,285,405.1Zm1.86.71-.58-.34-.18-.08-.18,0a.54.54,0,0,0-.18,0l-.19.07a.33.33,0,0,0-.12.11.17.17,0,0,0,0,.1.38.38,0,0,0,.08.11.56.56,0,0,0,.14.1,6.33,6.33,0,0,0,.58.34l.18.08.18,0a.55.55,0,0,0,.18,0,.45.45,0,0,0,.18-.07.32.32,0,0,0,.12-.1.14.14,0,0,0,0-.11.2.2,0,0,0-.07-.1A.85.85,0,0,0,286.81,405.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.86,404.94a.1.1,0,0,1-.08,0s0,0,0-.06l.07-.7s0,0,0-.06,0,0,.05-.06l.37-.21a.11.11,0,0,1,.08,0l.09,0,2.24,1.3a.05.05,0,0,1,0,.05s0,0,0,.05l-.4.22a.11.11,0,0,1-.08,0l-.09,0-1.52-.88,0,.39a.08.08,0,0,1,0,0,.16.16,0,0,1-.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,403.48a.92.92,0,0,1,.29.25.41.41,0,0,1,.08.27.48.48,0,0,1-.12.26.84.84,0,0,1-.28.24,1.59,1.59,0,0,1-.4.16,2.32,2.32,0,0,1-.46.07,1.88,1.88,0,0,1-.47-.05,1.49,1.49,0,0,1-.44-.17.83.83,0,0,1-.17-.12l-.11-.13a.75.75,0,0,1-.07-.12l-.05-.12-.32-.85a.08.08,0,0,0,0,0s0,0,0-.05l.48-.28h.07l.07,0,0,0s0,0,0,0l.22.58a1.71,1.71,0,0,1,.38-.13,3,3,0,0,1,.43,0l.42.06A1.52,1.52,0,0,1,291,403.48Zm-1.24.71a.44.44,0,0,0,.16.06l.18,0,.17,0,.15-.06a.43.43,0,0,0,.1-.09.2.2,0,0,0,0-.09.22.22,0,0,0,0-.11.35.35,0,0,0-.11-.09.52.52,0,0,0-.16-.06l-.18,0-.17,0-.14.06a.33.33,0,0,0-.11.09.41.41,0,0,0-.05.09.22.22,0,0,0,0,.11A.35.35,0,0,0,289.78,404.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.68,391.4l.17.12a.43.43,0,0,1,.13.14l.06.17a.67.67,0,0,1,0,.2l-.06.45.76-.43.08,0,.09,0,.37.22a.05.05,0,0,1,0,.05.05.05,0,0,1,0,.05l-1.58.91s0,0-.09,0l-.09,0-.3-.18-.09-.07a.1.1,0,0,1,0-.09l.15-.95a.22.22,0,0,0,0-.17.4.4,0,0,0-.12-.1l-.07,0-.12,0h-.15a.37.37,0,0,0-.17,0c-.06,0-.09.07-.1.1a.1.1,0,0,0,0,.09.3.3,0,0,0,0,.08l0,0s0,.05,0,.07,0,0-.06.05l-.37.21-.07,0-.07,0a1,1,0,0,1-.24-.2.52.52,0,0,1-.11-.24.43.43,0,0,1,.07-.26.82.82,0,0,1,.29-.25,1.38,1.38,0,0,1,.42-.17,2.18,2.18,0,0,1,.44,0,1.84,1.84,0,0,1,.41.06A1.94,1.94,0,0,1,310.68,391.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.08,390.23a1.38,1.38,0,0,1,.46-.18,1.52,1.52,0,0,1,.47,0,2.33,2.33,0,0,1,.46.08,4.08,4.08,0,0,1,.42.17l.32.18.3.18a2,2,0,0,1,.3.24.59.59,0,0,1,.14.27.39.39,0,0,1-.07.27.85.85,0,0,1-.31.27,1.38,1.38,0,0,1-.46.18,2.56,2.56,0,0,1-.47,0,1.79,1.79,0,0,1-.46-.09,1.94,1.94,0,0,1-.42-.17l-.31-.17-.31-.18a1.53,1.53,0,0,1-.3-.25.51.51,0,0,1-.14-.26.39.39,0,0,1,.07-.27A.7.7,0,0,1,311.08,390.23Zm1.86.7-.58-.34-.19-.08-.18,0h-.18a.45.45,0,0,0-.18.07.32.32,0,0,0-.12.1.14.14,0,0,0,0,.11.3.3,0,0,0,.07.1l.14.11.59.33.17.08a.58.58,0,0,0,.18,0h.19a.67.67,0,0,0,.18-.07.33.33,0,0,0,.12-.11.12.12,0,0,0,0-.1.34.34,0,0,0-.07-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,390.07l-.09,0a.05.05,0,0,1,0,0l.08-.7a.2.2,0,0,1,0-.07s0,0,.05-.06l.37-.21.08,0,.09,0,2.24,1.29s0,0,0,.05a.05.05,0,0,1,0,0l-.39.23-.09,0-.09,0-1.51-.87-.05.38a.05.05,0,0,1,0,.05h-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,389.9l0,0-1.1-1.38-.89.51-.09,0-.09,0-.36-.22a.08.08,0,0,1,0,0,.05.05,0,0,1,0-.05l1.44-.83h.08l.09,0,.33.19a.38.38,0,0,1,.12.13l1.1,1.38s0,0,0,.05a.05.05,0,0,1,0,.05l-.42.24a.11.11,0,0,1-.08,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.09,375.5l.18.12a.53.53,0,0,1,.12.14.49.49,0,0,1,.06.17.67.67,0,0,1,0,.2l-.05.45.75-.43.09,0a.16.16,0,0,1,.09,0l.36.21a.08.08,0,0,1,.05.05.05.05,0,0,1,0,.05l-1.59.91a.11.11,0,0,1-.08,0l-.09,0-.3-.18a.22.22,0,0,1-.09-.07.09.09,0,0,1,0-.09l.16-1a.18.18,0,0,0,0-.17.52.52,0,0,0-.11-.1l-.08,0-.12,0h-.15a.41.41,0,0,0-.17.05.46.46,0,0,0-.1.1.34.34,0,0,0,0,.09.35.35,0,0,0,0,.08l0,0s0,.05,0,.07,0,0-.06.05l-.37.21-.07,0-.07,0a1.59,1.59,0,0,1-.24-.2.5.5,0,0,1-.1-.24.37.37,0,0,1,.07-.26.74.74,0,0,1,.29-.25,1.54,1.54,0,0,1,.42-.17,2.09,2.09,0,0,1,.43,0,1.4,1.4,0,0,1,.41.06A1.5,1.5,0,0,1,338.09,375.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.49,374.33a1.43,1.43,0,0,1,.47-.18,1.83,1.83,0,0,1,.47,0,2.33,2.33,0,0,1,.46.08,4.08,4.08,0,0,1,.42.17l.32.18.3.18a2.47,2.47,0,0,1,.29.24.5.5,0,0,1,.14.27.34.34,0,0,1-.06.27,1,1,0,0,1-.31.27,1.43,1.43,0,0,1-.47.18,2.42,2.42,0,0,1-.47,0,1.79,1.79,0,0,1-.46-.09,1.94,1.94,0,0,1-.42-.17l-.31-.17-.31-.18a1.8,1.8,0,0,1-.29-.25.45.45,0,0,1-.14-.26.34.34,0,0,1,.06-.27A.77.77,0,0,1,338.49,374.33Zm1.86.7-.58-.34-.18-.07a.61.61,0,0,0-.18-.05h-.18a.4.4,0,0,0-.18.07.32.32,0,0,0-.12.1.11.11,0,0,0,0,.11.2.2,0,0,0,.07.1.57.57,0,0,0,.14.11l.58.33.18.08a.58.58,0,0,0,.18,0h.18a.67.67,0,0,0,.18-.07.33.33,0,0,0,.12-.11.18.18,0,0,0,0-.1.38.38,0,0,0-.08-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,374.17l-.08,0a.05.05,0,0,1,0-.05l.07-.7s0,0,0-.07a.13.13,0,0,1,.05-.06l.37-.21.08,0a.12.12,0,0,1,.09,0l2.24,1.29.05.05a.05.05,0,0,1,0,.05l-.4.23-.08,0s-.07,0-.09,0l-1.52-.87,0,.38a.07.07,0,0,1,0,.05H341Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,373.19a.65.65,0,0,1-.24-.22.36.36,0,0,1-.06-.24.48.48,0,0,1,.12-.25,1,1,0,0,1,.26-.22,2.15,2.15,0,0,1,.38-.15,2,2,0,0,1,.43-.07,2,2,0,0,1,.42,0,1.15,1.15,0,0,1,.38.14.74.74,0,0,1,.21.17.37.37,0,0,1,.09.19,1.58,1.58,0,0,1,.38,0,1.4,1.4,0,0,1,.34.13.74.74,0,0,1,.24.22.38.38,0,0,1,.05.25.5.5,0,0,1-.13.25,1,1,0,0,1-.29.24,2.4,2.4,0,0,1-.4.17,2.24,2.24,0,0,1-.44.07,1.53,1.53,0,0,1-.43,0,1.42,1.42,0,0,1-.38-.14.66.66,0,0,1-.23-.2.35.35,0,0,1-.07-.21l-.33-.05A1.14,1.14,0,0,1,342,373.19Zm.55-.32a.49.49,0,0,0,.25.05.6.6,0,0,0,.28-.08.25.25,0,0,0,.14-.16.14.14,0,0,0-.09-.15.62.62,0,0,0-.25,0,.74.74,0,0,0-.28.08c-.09.06-.13.11-.14.17A.17.17,0,0,0,342.53,372.87Zm.94.59a.4.4,0,0,0,.25.05.7.7,0,0,0,.32-.1c.11-.07.17-.13.18-.19s0-.1-.08-.14a.4.4,0,0,0-.25-.05.7.7,0,0,0-.32.1c-.11.07-.17.13-.18.19S343.4,373.42,343.47,373.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.74,362.43a.52.52,0,0,1,.17.12.43.43,0,0,1,.13.14.44.44,0,0,1,.06.16.67.67,0,0,1,0,.2l-.06.46.76-.44h.08l.09,0,.37.21s0,0,0,.06,0,0,0,0l-1.58.92-.09,0-.09,0-.3-.17-.09-.08a.09.09,0,0,1,0-.09l.15-.94a.25.25,0,0,0,0-.18.27.27,0,0,0-.12-.09l-.07,0-.12,0h-.15a.58.58,0,0,0-.17.06.19.19,0,0,0-.1.1.1.1,0,0,0,0,.09.16.16,0,0,0,0,.07l0,.05s0,.05,0,.06l-.06.06-.37.21h-.07a.08.08,0,0,1-.07,0,.68.68,0,0,1-.24-.2.44.44,0,0,1-.11-.24.4.4,0,0,1,.07-.25.83.83,0,0,1,.29-.26,1.81,1.81,0,0,1,.42-.16,1.64,1.64,0,0,1,.44,0,1.4,1.4,0,0,1,.41.06A1.14,1.14,0,0,1,360.74,362.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,361.25a2,2,0,0,1,.46-.18,1.89,1.89,0,0,1,.47,0,1.77,1.77,0,0,1,.46.08,1.94,1.94,0,0,1,.42.17,2.58,2.58,0,0,1,.32.18l.3.18a1.22,1.22,0,0,1,.3.24.56.56,0,0,1,.14.26.42.42,0,0,1-.07.28.85.85,0,0,1-.31.27,2,2,0,0,1-.46.18,1.89,1.89,0,0,1-.47,0,1.77,1.77,0,0,1-.46-.08,2.63,2.63,0,0,1-.42-.17l-.31-.17-.31-.19a1.22,1.22,0,0,1-.3-.24.56.56,0,0,1-.14-.26.41.41,0,0,1,.07-.28A.85.85,0,0,1,361.14,361.25ZM363,362l-.58-.34-.19-.08-.17,0a.4.4,0,0,0-.19,0l-.18.06a.33.33,0,0,0-.12.11.12.12,0,0,0,0,.1.34.34,0,0,0,.07.11l.14.1c.18.12.38.23.58.34l.18.08.19,0a.37.37,0,0,0,.18,0,.64.64,0,0,0,.18-.06.44.44,0,0,0,.12-.11.12.12,0,0,0,0-.1.19.19,0,0,0-.07-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,361.09a.12.12,0,0,1-.09,0,.09.09,0,0,1,0-.05l.08-.71a.15.15,0,0,1,0-.06s0,0,.05-.06l.37-.21a.11.11,0,0,1,.08,0l.09,0,2.24,1.3a.05.05,0,0,1,0,.05s0,0,0,.05l-.39.22s-.05,0-.09,0l-.09,0-1.51-.88,0,.39s0,0,0,0-.05,0-.09,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.63,360.23a.81.81,0,0,1-.29-.25.39.39,0,0,1-.07-.27.4.4,0,0,1,.11-.26.86.86,0,0,1,.27-.22,1.45,1.45,0,0,1,.38-.16,1.76,1.76,0,0,1,.46-.06,1.79,1.79,0,0,1,.46,0,1.55,1.55,0,0,1,.44.17l.17.12a.53.53,0,0,1,.1.12l.08.12a.61.61,0,0,0,.05.12l.34.86a.08.08,0,0,0,0,0s0,0,0,0l-.48.28h-.07l-.07,0,0,0v0l-.24-.58a2,2,0,0,1-.37.11,1.84,1.84,0,0,1-.41,0,2,2,0,0,1-.42-.05A1.34,1.34,0,0,1,364.63,360.23Zm1.2-.69a.34.34,0,0,0-.15-.06h-.17l-.16,0a.34.34,0,0,0-.15.06.39.39,0,0,0-.1.08.3.3,0,0,0,0,.1.16.16,0,0,0,0,.09.18.18,0,0,0,.1.09.34.34,0,0,0,.15.06l.17,0,.16,0a.34.34,0,0,0,.15-.06.39.39,0,0,0,.1-.08.18.18,0,0,0,0-.1.16.16,0,0,0,0-.09A.22.22,0,0,0,365.83,359.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.09,408.1c2.46-1.48-16.81-13-8.35-17.7s22.14,6.53,30.64,1.61c8.08-4.68-16.7-16.13-8.36-20.91s24.69,7.93,33.44,3.22c7.6-4.1-1.53-8.66,2.07-12.14s13.22.8,19.45-2.61-17.3-11-4.41-18.49l30.09,17.38-90,52.29Z",
    style: {
      fill: "#416259",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.13,408.29l-2.07-.39c.59-.38-1.64-2.52-3.44-4.24-4.5-4.32-10.66-10.24-4.9-13.46a11.63,11.63,0,0,1,5.13-1.36c3.9-.21,7.95,1,11.86,2.1,3.53,1,7.18,2.09,10,1.93a7.87,7.87,0,0,0,3.62-1.06c3.75-2.17-.34-6.15-4.28-10-4.2-4.1-8.55-8.34-4.07-10.9a10.85,10.85,0,0,1,4.89-1.27c4.25-.2,8.73,1.24,13.48,2.76,4.2,1.34,8.53,2.73,11.77,2.59a7.48,7.48,0,0,0,3.3-.87c4.14-2.23,3-4.64,2-7-.83-1.81-1.62-3.53,0-5.1,2.12-2.05,6.49-1.8,10-1.6,3.67.21,6.84.4,9.56-1.09,2.24-1.22-.11-3.26-2.83-5.62-4.24-3.69-9.52-8.28-1.6-12.85l2.06.39c-7.36,4.25-2.3,8.64,1.76,12.18,2.94,2.55,5.48,4.76,2.64,6.32-3.55,1.94-8.23,1.67-12,1.45s-5.9-.33-7.36,1.08-.69,3,.1,4.72c1.09,2.35,2.32,5-2.29,7.49a11.5,11.5,0,0,1-5,1.24c-4.36.19-8.9-1.26-13.71-2.8-4.14-1.33-8.41-2.69-11.51-2.55a7,7,0,0,0-3.17.89c-3.93,2.25.24,6.31,4.26,10.25,4.31,4.2,8.38,8.18,4.1,10.66a11.75,11.75,0,0,1-5.29,1.44c-3.94.22-8-1-12-2.11-3.5-1-7.12-2.07-9.92-1.92a7.88,7.88,0,0,0-3.47,1c-5.19,2.91,1,8.86,5.11,12.8C263.83,406.24,265.21,407.64,264.13,408.29Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,372.41a1.07,1.07,0,0,1-.63-.05l-.46-.27c-.12-.07,0-.16.17-.21a1.14,1.14,0,0,1,.63.06l.46.26C279.59,372.28,279.52,372.37,279.3,372.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.55,387.57a1.14,1.14,0,0,1-.63-.06L304,387c-.12-.07-.05-.17.17-.21a1,1,0,0,1,.62.06l.94.54C305.84,387.43,305.76,387.52,305.55,387.57Zm-1.88-1.09a1.07,1.07,0,0,1-.63-.05l-.93-.54c-.13-.08-.05-.17.16-.21a1.15,1.15,0,0,1,.63.05l.94.55C304,386.35,303.89,386.44,303.67,386.48Zm-1.87-1.08a1.15,1.15,0,0,1-.63,0l-.94-.55c-.12-.07-.05-.16.17-.2a1.07,1.07,0,0,1,.63,0l.93.54C302.09,385.27,302,385.36,301.8,385.4Zm-1.88-1.08a1.06,1.06,0,0,1-.63-.06l-.93-.54c-.13-.07-.05-.16.17-.21a1.12,1.12,0,0,1,.62.06l.94.54C300.21,384.18,300.14,384.28,299.92,384.32Zm-1.87-1.08a1.14,1.14,0,0,1-.63-.06l-.94-.54c-.12-.07-.05-.17.17-.21a1.06,1.06,0,0,1,.63.06l.93.54C298.34,383.1,298.26,383.19,298.05,383.24Zm-1.88-1.09a1,1,0,0,1-.62,0l-.94-.54c-.13-.08-.05-.17.17-.21a1.13,1.13,0,0,1,.62,0l.94.55C296.47,382,296.39,382.11,296.17,382.15Zm-1.87-1.08a1.15,1.15,0,0,1-.63-.05l-.94-.54c-.12-.08-.05-.17.17-.21a1.07,1.07,0,0,1,.63.05l.93.54C294.59,380.94,294.52,381,294.3,381.07ZM292.42,380a1,1,0,0,1-.62-.06l-.94-.54c-.13-.07-.05-.16.17-.21a1.1,1.1,0,0,1,.62.06l.94.54C292.72,379.85,292.64,380,292.42,380Zm-1.87-1.08a1.14,1.14,0,0,1-.63-.06l-.94-.54c-.12-.07-.05-.17.17-.21a1.06,1.06,0,0,1,.63.06l.93.54C290.84,378.77,290.77,378.86,290.55,378.91Zm-1.88-1.09a1,1,0,0,1-.62-.05l-.94-.54c-.13-.08-.05-.17.17-.21a1,1,0,0,1,.62.06l.94.54C289,377.69,288.89,377.78,288.67,377.82Zm-1.87-1.08a1.15,1.15,0,0,1-.63-.05l-.94-.54c-.12-.08-.05-.17.17-.21a1.07,1.07,0,0,1,.63.05l.94.54C287.09,376.61,287,376.7,286.8,376.74Zm-1.88-1.08a1,1,0,0,1-.62-.06l-.94-.54c-.13-.07-.05-.16.17-.21a1.1,1.1,0,0,1,.62.06l.94.54C285.22,375.52,285.14,375.62,284.92,375.66Zm-1.87-1.08a1.14,1.14,0,0,1-.63-.06l-.93-.54c-.13-.07-.06-.17.16-.21a1.14,1.14,0,0,1,.63.06l.94.54C283.34,374.44,283.27,374.54,283.05,374.58Zm-1.88-1.08a1.1,1.1,0,0,1-.62-.06l-.94-.54c-.13-.07-.05-.17.17-.21a1,1,0,0,1,.62.06l.94.54C281.47,373.36,281.39,373.45,281.17,373.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,388.37a1.15,1.15,0,0,1-.63-.05l-.45-.27c-.13-.07-.05-.16.16-.21a1.14,1.14,0,0,1,.63.06l.46.26C307.23,388.24,307.16,388.33,306.94,388.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.81,403.46a1.14,1.14,0,0,1-.63-.06l-.94-.54c-.12-.07-.05-.17.17-.21a1.06,1.06,0,0,1,.63.06l.94.54C278.1,403.32,278,403.41,277.81,403.46Zm-1.88-1.09a1,1,0,0,1-.62-.05l-.94-.54c-.13-.08-.05-.17.17-.21a1.11,1.11,0,0,1,.62.05l.94.55C276.23,402.24,276.15,402.33,275.93,402.37Zm-1.87-1.08a1.15,1.15,0,0,1-.63-.05l-.93-.54c-.13-.08-.06-.17.16-.21a1.07,1.07,0,0,1,.63.05l.94.54C274.35,401.16,274.28,401.25,274.06,401.29Zm-1.88-1.08a1,1,0,0,1-.62-.06l-.94-.54c-.13-.07-.05-.16.17-.21a1.1,1.1,0,0,1,.62.06l.94.54C272.48,400.07,272.4,400.17,272.18,400.21Zm-1.87-1.08a1.14,1.14,0,0,1-.63-.06l-.93-.54c-.13-.07-.06-.17.16-.21a1.06,1.06,0,0,1,.63.06l.94.54C270.6,399,270.53,399.08,270.31,399.13Zm-1.88-1.08a1.12,1.12,0,0,1-.62-.06l-.94-.54c-.13-.08-.05-.17.17-.21a1,1,0,0,1,.62.06l.94.54C268.73,397.91,268.65,398,268.43,398.05ZM266.56,397a1.15,1.15,0,0,1-.63,0l-.93-.54c-.13-.08-.05-.17.16-.21a1.07,1.07,0,0,1,.63,0l.94.54C266.85,396.83,266.78,396.92,266.56,397Zm-1.88-1.08a1,1,0,0,1-.62-.06l-.94-.54c-.12-.07-.05-.16.17-.21a1.14,1.14,0,0,1,.63.06l.93.54C265,395.74,264.9,395.84,264.68,395.88Zm-1.87-1.08a1.14,1.14,0,0,1-.63-.06l-.93-.54c-.13-.07-.05-.17.16-.21a1.14,1.14,0,0,1,.63.06l.94.54C263.1,394.66,263,394.76,262.81,394.8Zm-1.87-1.08a1.14,1.14,0,0,1-.63-.06l-.94-.54c-.12-.07-.05-.17.17-.21a1.06,1.06,0,0,1,.63.06l.93.54C261.23,393.58,261.15,393.67,260.94,393.72Zm-1.88-1.09a1,1,0,0,1-.62-.05l-.94-.54c-.13-.08-.05-.17.17-.21a1.13,1.13,0,0,1,.62.05l.94.54C259.35,392.5,259.28,392.59,259.06,392.63Zm-1.87-1.08a1.06,1.06,0,0,1-.63-.06l-.94-.54c-.12-.07-.05-.16.17-.2a1.07,1.07,0,0,1,.63.05l.93.54C257.48,391.42,257.4,391.51,257.19,391.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,404.26a1.11,1.11,0,0,1-.62-.05l-.46-.27c-.13-.07-.05-.16.17-.21a1.1,1.1,0,0,1,.62.06l.46.26C279.5,404.13,279.42,404.22,279.2,404.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,362.1a1,1,0,0,1-.62-.06l-.46-.26c-.13-.08-.05-.17.16-.21a1.15,1.15,0,0,1,.63.05l.46.27C316,362,315.92,362.06,315.7,362.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.45,371.77a1.14,1.14,0,0,1-.63-.06l-.93-.54c-.12-.07-.05-.16.17-.2a1.07,1.07,0,0,1,.63,0l.93.54C332.74,371.63,332.67,371.73,332.45,371.77Zm-1.86-1.08a1.07,1.07,0,0,1-.63-.05l-.93-.54c-.13-.07,0-.17.17-.21a1,1,0,0,1,.62.06l.94.53C330.88,370.56,330.81,370.65,330.59,370.69Zm-1.86-1.07a1.06,1.06,0,0,1-.63-.06l-.93-.53c-.13-.08-.05-.17.17-.21a1,1,0,0,1,.62.05l.93.54C329,369.48,329,369.58,328.73,369.62Zm-1.86-1.08a1.07,1.07,0,0,1-.63-.05l-.93-.54c-.13-.07-.05-.17.17-.21a1.1,1.1,0,0,1,.62.06l.93.54C327.16,368.41,327.09,368.5,326.87,368.54ZM325,367.47a1,1,0,0,1-.62-.06l-.93-.53c-.13-.08-.05-.17.17-.21a1.11,1.11,0,0,1,.62.05l.93.54C325.3,367.33,325.22,367.43,325,367.47Zm-1.86-1.07a1.1,1.1,0,0,1-.62-.06l-.93-.54c-.13-.07,0-.16.17-.21a1.1,1.1,0,0,1,.62.06l.93.54C323.44,366.26,323.36,366.35,323.14,366.4Zm-1.86-1.08a1.11,1.11,0,0,1-.62-.05l-.93-.54c-.13-.08-.05-.17.16-.21a1.06,1.06,0,0,1,.63.06l.93.53C321.58,365.19,321.5,365.28,321.28,365.32Zm-1.86-1.07a1.1,1.1,0,0,1-.62-.06l-.93-.54c-.13-.07-.06-.16.16-.21a1.14,1.14,0,0,1,.63.06l.93.54C319.72,364.11,319.64,364.2,319.42,364.25Zm-1.86-1.08a1.11,1.11,0,0,1-.62-.05l-.93-.54c-.13-.07-.06-.17.16-.21a1.06,1.06,0,0,1,.63.06l.93.53C317.86,363,317.78,363.13,317.56,363.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.84,372.57a1.06,1.06,0,0,1-.63-.06l-.46-.26c-.12-.07-.05-.17.17-.21a1.06,1.06,0,0,1,.63.06l.46.26C334.13,372.43,334.06,372.53,333.84,372.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.44 366.58 271.14 364.1 265.47 367.38 269.77 369.87 272.13 368.5 274.83 369.43 273.62 367.63 273.62 367.63 275.44 366.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.91 386.34 248.61 383.86 242.95 387.14 247.25 389.62 249.6 388.26 252.31 389.19 251.1 387.39 251.1 387.39 252.91 386.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 357.37 308.89 354.89 303.23 358.18 307.53 360.66 309.88 359.29 312.59 360.23 311.38 358.42 311.38 358.42 313.19 357.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82,422.2l.12,0a.18.18,0,0,1,.13,0l.54.31a.12.12,0,0,1,.07.07.31.31,0,0,1,0,.08l.09.66a2.75,2.75,0,0,1,.9-.12,1.81,1.81,0,0,1,.85.24c.39.22.56.46.52.7s-.26.48-.67.72a2.73,2.73,0,0,1-.64.27,2.53,2.53,0,0,1-.64.11,2.18,2.18,0,0,1-.58,0,1.3,1.3,0,0,1-.47-.16s0,0-.05-.06a.07.07,0,0,1,0-.06l.55-.32a.45.45,0,0,1,.19-.05H302l.26,0a1,1,0,0,0,.32-.13.6.6,0,0,0,.27-.25c0-.08,0-.16-.12-.23a.6.6,0,0,0-.4-.07,1.5,1.5,0,0,0-.43.16l-.37.21a.16.16,0,0,1-.12,0,.28.28,0,0,1-.13,0l-.44-.25s-.06-.05-.07-.08,0-.06,0-.08l-.08-.59-1.14.67a.35.35,0,0,1-.26,0l-.54-.31a.16.16,0,0,1-.06-.08.08.08,0,0,1,0-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.74,421a2.27,2.27,0,0,1,.68-.26,2.39,2.39,0,0,1,.7,0,3,3,0,0,1,.67.11,3.38,3.38,0,0,1,.62.26l.46.25c.16.1.31.18.44.27a2.71,2.71,0,0,1,.44.35.81.81,0,0,1,.2.39.59.59,0,0,1-.09.4,1.23,1.23,0,0,1-.46.39,2.2,2.2,0,0,1-.68.27,2.68,2.68,0,0,1-.69,0,2.55,2.55,0,0,1-.67-.12,3.82,3.82,0,0,1-.62-.25l-.45-.25-.45-.27a2,2,0,0,1-.44-.36.73.73,0,0,1-.2-.39.6.6,0,0,1,.09-.4A1.28,1.28,0,0,1,302.74,421Zm2.73,1c-.28-.17-.56-.34-.85-.49l-.27-.12a1.22,1.22,0,0,0-.26-.06.82.82,0,0,0-.27,0,.93.93,0,0,0-.26.1.47.47,0,0,0-.18.15.18.18,0,0,0,0,.16.33.33,0,0,0,.1.15,1.27,1.27,0,0,0,.21.15c.26.17.55.34.85.5l.26.11a.9.9,0,0,0,.27.07.76.76,0,0,0,.26,0,.74.74,0,0,0,.27-.1.43.43,0,0,0,.17-.15.16.16,0,0,0,0-.15.31.31,0,0,0-.1-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.54,419.71a2.71,2.71,0,0,1,.38.22.75.75,0,0,1,.23.19.41.41,0,0,1,.1.21.29.29,0,0,1-.06.21.55.55,0,0,1-.24.2,1,1,0,0,1-.35.14,1.61,1.61,0,0,1-.37,0l-.36-.06a2.26,2.26,0,0,1-.33-.13l-.2-.11-.19-.12a.84.84,0,0,1-.22-.19.39.39,0,0,1-.11-.21.29.29,0,0,1,.06-.21.71.71,0,0,1,.24-.2,1.34,1.34,0,0,1,.36-.14,1.14,1.14,0,0,1,.37,0,1.34,1.34,0,0,1,.35.05A2,2,0,0,1,306.54,419.71Zm-.52.71a1.29,1.29,0,0,0,.25.09.34.34,0,0,0,.2,0c.06,0,.09-.08.07-.12a.41.41,0,0,0-.15-.14,3.79,3.79,0,0,0-.34-.2,1,1,0,0,0-.24-.08.28.28,0,0,0-.2,0c-.07,0-.09.07-.07.11a.41.41,0,0,0,.15.14A2.63,2.63,0,0,0,306,420.42Zm1-1.7a.09.09,0,0,1,0-.07s0,0,.07-.07l.36-.21a.18.18,0,0,1,.2,0l0,0a0,0,0,0,1,0,0l1.13,3.16a.12.12,0,0,1,0,.08.22.22,0,0,1-.07.07l-.36.21-.11,0a.18.18,0,0,1-.1,0l0,0,0,0Zm3.31.83a3.36,3.36,0,0,1,.39.23.9.9,0,0,1,.23.19.38.38,0,0,1,.1.2.3.3,0,0,1-.06.22.55.55,0,0,1-.24.2,1.17,1.17,0,0,1-.35.14,1.18,1.18,0,0,1-.37,0,1.49,1.49,0,0,1-.36-.05,2.33,2.33,0,0,1-.33-.14,1.86,1.86,0,0,1-.2-.1l-.19-.12a1.55,1.55,0,0,1-.23-.19.5.5,0,0,1-.1-.21.29.29,0,0,1,.06-.21.71.71,0,0,1,.24-.2,1.07,1.07,0,0,1,.36-.14,1.47,1.47,0,0,1,.36,0,2.25,2.25,0,0,1,.36.06A3.24,3.24,0,0,1,310.35,419.55Zm-.51.71a.85.85,0,0,0,.25.09.29.29,0,0,0,.2,0c.06,0,.09-.07.07-.11a.38.38,0,0,0-.16-.14,2.63,2.63,0,0,0-.33-.2l-.24-.08a.28.28,0,0,0-.2,0c-.07,0-.09.08-.07.12a.41.41,0,0,0,.15.14A1.77,1.77,0,0,0,309.84,420.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,419.29l-3.72-1.1a5.56,5.56,0,0,0-1.28,4.7l4.11-.38A4,4,0,0,1,295,419.29Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.75,417.66l3.71,1.09a8,8,0,0,1,1.72-1.31,12.69,12.69,0,0,1,2.28-1l-1.89-2.14a17.25,17.25,0,0,0-3.33,1.44A11.28,11.28,0,0,0,291.75,417.66Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,415.66l.65-2.37a24.75,24.75,0,0,0-8.13.74l1.89,2.14A18,18,0,0,1,306,415.66Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.27,423.11l-4.12.37a8.4,8.4,0,0,0,3.74,4.23l2.94-1.69A6.09,6.09,0,0,1,294.27,423.11Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.57,426.44l-2.95,1.7A20.47,20.47,0,0,0,302,430.3l.65-2.38A14.51,14.51,0,0,1,297.57,426.44Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,428l-.65,2.37a25,25,0,0,0,8.13-.74l-1.89-2.14A18.2,18.2,0,0,1,303.63,428Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.42,426.24a11.63,11.63,0,0,1-2.27,1l1.89,2.15a16.59,16.59,0,0,0,3.32-1.45,11.33,11.33,0,0,0,2.5-1.91l-3.71-1.1A8.37,8.37,0,0,1,312.42,426.24Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.62,424.39l3.71,1.09a5.5,5.5,0,0,0,1.28-4.69l-4.11.37A4,4,0,0,1,314.62,424.39Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,417.24l2.94-1.7a20.35,20.35,0,0,0-7.33-2.16l-.65,2.37A14.73,14.73,0,0,1,312,417.24Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34,420.57l4.12-.38a8.36,8.36,0,0,0-3.74-4.23l-3,1.7A6,6,0,0,1,315.34,420.57Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.75,417.66l3.71,1.09a8,8,0,0,1,1.72-1.31,12.69,12.69,0,0,1,2.28-1l-1.89-2.14a17.25,17.25,0,0,0-3.33,1.44A11.28,11.28,0,0,0,291.75,417.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,415.66l.65-2.37a24.75,24.75,0,0,0-8.13.74l1.89,2.14A18,18,0,0,1,306,415.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312,417.24l2.94-1.7a20.35,20.35,0,0,0-7.33-2.16l-.65,2.37A14.73,14.73,0,0,1,312,417.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M338.16,403.52h.35l.2,0,.21-.09a.44.44,0,0,0,.15-.12.31.31,0,0,0,.06-.13.18.18,0,0,0,0-.14.36.36,0,0,0-.16-.13.74.74,0,0,0-.4-.1.85.85,0,0,0-.43.12.36.36,0,0,0-.09.08l-.06.09,0,.07-.05,0-.68.4a.19.19,0,0,1-.13,0,.2.2,0,0,1-.13,0l-1.68-1.12a.16.16,0,0,1-.06-.08.09.09,0,0,1,0-.07l1.88-1.08a.28.28,0,0,1,.13,0l.13,0,.54.31a.09.09,0,0,1,.06.08.09.09,0,0,1,0,.07l-1.28.74.42.27a.44.44,0,0,1,.1-.15.79.79,0,0,1,.19-.15,2.45,2.45,0,0,1,.55-.23,2.57,2.57,0,0,1,.62-.08,2.68,2.68,0,0,1,.62.07,2.45,2.45,0,0,1,.61.25,1.24,1.24,0,0,1,.43.37.52.52,0,0,1,.13.38.66.66,0,0,1-.17.37,1.33,1.33,0,0,1-.42.34,2.56,2.56,0,0,1-.62.26,3.65,3.65,0,0,1-.64.09,2.35,2.35,0,0,1-.6-.06,2.17,2.17,0,0,1-.49-.17s-.05,0-.05-.07a.05.05,0,0,1,0-.05l.56-.33a.43.43,0,0,1,.14,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,400.07a2.27,2.27,0,0,1,.68-.26,2.8,2.8,0,0,1,.7-.06,2.55,2.55,0,0,1,.67.12,3.71,3.71,0,0,1,.61.25l.47.26c.16.09.31.18.44.27a1.93,1.93,0,0,1,.43.35.75.75,0,0,1,.21.39.6.6,0,0,1-.09.4,1.44,1.44,0,0,1-.46.39,2,2,0,0,1-.68.26,2.69,2.69,0,0,1-.69.06,2.48,2.48,0,0,1-.67-.12,3.82,3.82,0,0,1-.62-.25l-.46-.25-.44-.27a2,2,0,0,1-.44-.36.79.79,0,0,1-.21-.39.56.56,0,0,1,.1-.4A1.28,1.28,0,0,1,339,400.07Zm2.73,1c-.28-.17-.56-.34-.85-.49a1.59,1.59,0,0,0-.27-.12l-.26-.06a.83.83,0,0,0-.53.11.47.47,0,0,0-.18.15.18.18,0,0,0,0,.16.33.33,0,0,0,.1.15,1.27,1.27,0,0,0,.21.15,8.61,8.61,0,0,0,.85.49,1.51,1.51,0,0,0,.26.12,1.31,1.31,0,0,0,.27.06.77.77,0,0,0,.26,0,.74.74,0,0,0,.27-.1.43.43,0,0,0,.17-.15.18.18,0,0,0,0-.16.36.36,0,0,0-.11-.15A1.15,1.15,0,0,0,341.76,401.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.82,398.74a3.36,3.36,0,0,1,.39.23.9.9,0,0,1,.23.19.35.35,0,0,1,.1.2.3.3,0,0,1-.06.22.62.62,0,0,1-.24.2,1.17,1.17,0,0,1-.35.14,1.61,1.61,0,0,1-.37,0,2.25,2.25,0,0,1-.36-.06,2.33,2.33,0,0,1-.33-.14l-.2-.1-.19-.12a1.11,1.11,0,0,1-.23-.19.5.5,0,0,1-.1-.21.29.29,0,0,1,.06-.21.71.71,0,0,1,.24-.2,1.07,1.07,0,0,1,.36-.14,1.47,1.47,0,0,1,.36,0,2.08,2.08,0,0,1,.36.06A1.89,1.89,0,0,1,342.82,398.74Zm-.51.72a1.17,1.17,0,0,0,.25.08.29.29,0,0,0,.2,0c.06,0,.09-.07.07-.11a.38.38,0,0,0-.16-.14,2.63,2.63,0,0,0-.33-.2l-.24-.08a.24.24,0,0,0-.2,0c-.07,0-.09.07-.07.11a.41.41,0,0,0,.15.14A2.63,2.63,0,0,0,342.31,399.46Zm1-1.7a.11.11,0,0,1,0-.08s0,0,.07-.06l.36-.21a.18.18,0,0,1,.2,0h0v0l1.13,3.16a.22.22,0,0,1,0,.08.22.22,0,0,1-.07.07l-.36.2a.2.2,0,0,1-.11,0l-.1,0,0,0,0,0Zm3.32.83.39.22a1.57,1.57,0,0,1,.23.2.35.35,0,0,1,.1.2.32.32,0,0,1-.06.22.84.84,0,0,1-.24.2,1.22,1.22,0,0,1-.36.14,1.1,1.1,0,0,1-.36,0,1.13,1.13,0,0,1-.36-.06,1.51,1.51,0,0,1-.33-.13l-.2-.1-.19-.12a1.55,1.55,0,0,1-.23-.19.5.5,0,0,1-.1-.21.29.29,0,0,1,.06-.21.73.73,0,0,1,.24-.21,1.58,1.58,0,0,1,.36-.14,1.46,1.46,0,0,1,.36,0l.36.06A1.89,1.89,0,0,1,346.64,398.59Zm-.51.71a.85.85,0,0,0,.25.09.29.29,0,0,0,.2,0c.06,0,.08-.07.06-.11a.51.51,0,0,0-.15-.15,2.59,2.59,0,0,0-.33-.19.85.85,0,0,0-.25-.09.38.38,0,0,0-.2,0q-.09.06-.06.12s.07.08.15.14A2.59,2.59,0,0,0,346.13,399.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.32,398.3l-3.71-1.1a5.53,5.53,0,0,0-1.28,4.7l4.11-.38A4,4,0,0,1,331.32,398.3Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,396.67l3.71,1.09a8.34,8.34,0,0,1,1.73-1.31,12.28,12.28,0,0,1,2.27-1l-1.89-2.14a17.15,17.15,0,0,0-3.32,1.44A11.35,11.35,0,0,0,328.08,396.67Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,394.67l.65-2.37a24.73,24.73,0,0,0-8.13.74l1.89,2.14A18,18,0,0,1,342.31,394.67Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.6,402.12l-4.12.37a8.42,8.42,0,0,0,3.75,4.23l2.94-1.69A6.12,6.12,0,0,1,330.6,402.12Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.91,405.45l-3,1.7a20.35,20.35,0,0,0,7.33,2.16l.65-2.38A14.39,14.39,0,0,1,333.91,405.45Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,407l-.65,2.37a25,25,0,0,0,8.13-.74l-1.89-2.15A18.26,18.26,0,0,1,340,407Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.76,405.25a12.36,12.36,0,0,1-2.28,1l1.89,2.15a16.43,16.43,0,0,0,3.33-1.45,11.33,11.33,0,0,0,2.5-1.91l-3.72-1.1A8,8,0,0,1,348.76,405.25Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,403.4l3.72,1.09A5.53,5.53,0,0,0,356,399.8l-4.11.37A4,4,0,0,1,351,403.4Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.37,396.25l2.95-1.7a20.47,20.47,0,0,0-7.33-2.16l-.66,2.37A14.67,14.67,0,0,1,348.37,396.25Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.68,399.58l4.11-.38a8.27,8.27,0,0,0-3.74-4.23l-2.94,1.7A6.06,6.06,0,0,1,351.68,399.58Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,396.67l3.71,1.09a8.34,8.34,0,0,1,1.73-1.31,12.28,12.28,0,0,1,2.27-1l-1.89-2.14a17.15,17.15,0,0,0-3.32,1.44A11.35,11.35,0,0,0,328.08,396.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,394.67l.65-2.37a24.73,24.73,0,0,0-8.13.74l1.89,2.14A18,18,0,0,1,342.31,394.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,403.4l3.72,1.09A5.53,5.53,0,0,0,356,399.8l-4.11.37A4,4,0,0,1,351,403.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M348.37,396.25l2.95-1.7a20.47,20.47,0,0,0-7.33-2.16l-.66,2.37A14.67,14.67,0,0,1,348.37,396.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M351.68,399.58l4.11-.38a8.27,8.27,0,0,0-3.74-4.23l-2.94,1.7A6.06,6.06,0,0,1,351.68,399.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.2,383.2l-.05,0-1.61-2-1.31.76a.16.16,0,0,1-.12,0,.32.32,0,0,1-.14,0l-.53-.31a.13.13,0,0,1-.07-.08s0-.05.05-.07l2.1-1.21a.21.21,0,0,1,.12,0,.33.33,0,0,1,.14,0l.47.27a.82.82,0,0,1,.19.19l1.61,2,0,.08a.08.08,0,0,1,0,.07l-.61.35a.14.14,0,0,1-.11,0A.21.21,0,0,1,375.2,383.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,379.16a2.57,2.57,0,0,1,.68-.26,2.39,2.39,0,0,1,.7,0,2.55,2.55,0,0,1,.67.12,3.35,3.35,0,0,1,.62.25l.46.26.44.26a2.25,2.25,0,0,1,.43.35.75.75,0,0,1,.21.39.58.58,0,0,1-.09.4,1.33,1.33,0,0,1-.46.4,2.45,2.45,0,0,1-.68.26,2.68,2.68,0,0,1-.69,0,2.48,2.48,0,0,1-.67-.12,3.09,3.09,0,0,1-.62-.25l-.45-.25c-.17-.09-.31-.18-.45-.27a2,2,0,0,1-.44-.36.74.74,0,0,1-.2-.38.53.53,0,0,1,.09-.4A1.2,1.2,0,0,1,375.22,379.16Zm2.73,1-.85-.49-.27-.11a.92.92,0,0,0-.26-.07,1.22,1.22,0,0,0-.27,0,.93.93,0,0,0-.26.1.41.41,0,0,0-.18.16.16.16,0,0,0,0,.15.33.33,0,0,0,.1.15l.21.16c.26.17.55.33.85.49l.26.12.27.06a1.15,1.15,0,0,0,.26,0,1,1,0,0,0,.27-.1.44.44,0,0,0,.17-.16.16.16,0,0,0,0-.15.29.29,0,0,0-.11-.15A1.16,1.16,0,0,0,378,380.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,377.84a2.71,2.71,0,0,1,.38.22,1.16,1.16,0,0,1,.23.19.41.41,0,0,1,.1.21.29.29,0,0,1-.06.21.64.64,0,0,1-.24.21,1.51,1.51,0,0,1-.35.14l-.37,0-.36-.06a2.26,2.26,0,0,1-.33-.13l-.2-.11-.19-.11a1.57,1.57,0,0,1-.23-.2.42.42,0,0,1-.1-.2.32.32,0,0,1,.06-.22.84.84,0,0,1,.24-.2,1.34,1.34,0,0,1,.36-.14,1.47,1.47,0,0,1,.72,0A1.4,1.4,0,0,1,379,377.84Zm-.52.71a.85.85,0,0,0,.25.09.29.29,0,0,0,.2,0c.06,0,.09-.08.07-.12a.38.38,0,0,0-.16-.14,2.59,2.59,0,0,0-.33-.19.76.76,0,0,0-.25-.09.27.27,0,0,0-.19,0c-.07,0-.09.07-.07.11a.51.51,0,0,0,.15.15A2.59,2.59,0,0,0,378.5,378.55Zm1-1.69a.11.11,0,0,1,0-.08s0,0,.07-.07l.36-.21a.18.18,0,0,1,.2,0l0,0a0,0,0,0,1,0,0l1.13,3.16a.25.25,0,0,1,0,.08.15.15,0,0,1-.07.07l-.36.21a.2.2,0,0,1-.11,0,.19.19,0,0,1-.1,0l0,0s0,0,0,0Zm3.32.83a2.36,2.36,0,0,1,.39.22,1.11,1.11,0,0,1,.23.19.37.37,0,0,1,.1.21.29.29,0,0,1-.06.21.71.71,0,0,1-.24.2,1,1,0,0,1-.35.14,1.61,1.61,0,0,1-.37,0,2.25,2.25,0,0,1-.36-.06,3.24,3.24,0,0,1-.33-.13l-.2-.11-.19-.12a1.11,1.11,0,0,1-.23-.19.5.5,0,0,1-.1-.21.29.29,0,0,1,.06-.21.71.71,0,0,1,.24-.2,1,1,0,0,1,.36-.14,1.1,1.1,0,0,1,.36,0,1.49,1.49,0,0,1,.36.05A1.92,1.92,0,0,1,382.83,377.69Zm-.51.71a1.17,1.17,0,0,0,.25.08.28.28,0,0,0,.2,0c.06,0,.08-.08.07-.12a.38.38,0,0,0-.16-.14,1.77,1.77,0,0,0-.33-.19.85.85,0,0,0-.25-.09.3.3,0,0,0-.2,0c-.06,0-.08.07-.06.11s.07.09.15.14A2.63,2.63,0,0,0,382.32,378.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,377.31l-3.72-1.1a5.56,5.56,0,0,0-1.28,4.7l4.11-.38A4,4,0,0,1,367.66,377.31Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,375.68l3.71,1.09a8.08,8.08,0,0,1,1.73-1.31,12.28,12.28,0,0,1,2.27-1l-1.89-2.14a17.15,17.15,0,0,0-3.32,1.44A11.35,11.35,0,0,0,364.42,375.68Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.64,373.68l.65-2.37a24.75,24.75,0,0,0-8.13.74l1.9,2.14A17.86,17.86,0,0,1,378.64,373.68Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.94,381.13l-4.12.37a8.44,8.44,0,0,0,3.74,4.23L369.5,384A6.09,6.09,0,0,1,366.94,381.13Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.24,384.46l-2.95,1.7a20.47,20.47,0,0,0,7.34,2.16l.65-2.38A14.51,14.51,0,0,1,370.24,384.46Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,386l-.65,2.37a25,25,0,0,0,8.13-.74l-1.9-2.15A18.17,18.17,0,0,1,376.31,386Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,384.26a12.26,12.26,0,0,1-2.27,1l1.89,2.15A16.59,16.59,0,0,0,388,386a11.33,11.33,0,0,0,2.5-1.91l-3.71-1.1A8.11,8.11,0,0,1,385.09,384.26Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,382.41,391,383.5a5.49,5.49,0,0,0,1.27-4.69l-4.1.37A4,4,0,0,1,387.29,382.41Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,375.26l3-1.7a20.47,20.47,0,0,0-7.34-2.16l-.65,2.37A14.73,14.73,0,0,1,384.71,375.26Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,378.59l4.12-.38a8.31,8.31,0,0,0-3.74-4.23l-2.95,1.7A5.92,5.92,0,0,1,388,378.59Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364.42,375.68l3.71,1.09a8.08,8.08,0,0,1,1.73-1.31,12.28,12.28,0,0,1,2.27-1l-1.89-2.14a17.15,17.15,0,0,0-3.32,1.44A11.35,11.35,0,0,0,364.42,375.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M378.64,373.68l.65-2.37a24.75,24.75,0,0,0-8.13.74l1.9,2.14A17.86,17.86,0,0,1,378.64,373.68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.31,386l-.65,2.37a25,25,0,0,0,8.13-.74l-1.9-2.15A18.17,18.17,0,0,1,376.31,386Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M385.09,384.26a12.26,12.26,0,0,1-2.27,1l1.89,2.15A16.59,16.59,0,0,0,388,386a11.33,11.33,0,0,0,2.5-1.91l-3.71-1.1A8.11,8.11,0,0,1,385.09,384.26Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.29,382.41,391,383.5a5.49,5.49,0,0,0,1.27-4.69l-4.1.37A4,4,0,0,1,387.29,382.41Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M384.71,375.26l3-1.7a20.47,20.47,0,0,0-7.34-2.16l-.65,2.37A14.73,14.73,0,0,1,384.71,375.26Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M388,378.59l4.12-.38a8.31,8.31,0,0,0-3.74-4.23l-2.95,1.7A5.92,5.92,0,0,1,388,378.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222,192.2a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.5.5,0,1,1,.5.86l-32.49,18.77A.57.57,0,0,1,222,192.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222,196.89a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.5.5,0,1,1,.5.86l-32.49,18.77A.57.57,0,0,1,222,196.89Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222,201.58a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.5.5,0,1,1,.5.86l-32.49,18.77A.57.57,0,0,1,222,201.58Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222,206.27a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.5.5,0,1,1,.5.86l-32.49,18.77A.57.57,0,0,1,222,206.27Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M222,211a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69L222.24,210.9A.57.57,0,0,1,222,211Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M222,215.65a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68L254.23,196a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-32.49,18.76A.57.57,0,0,1,222,215.65Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222,220.34a.49.49,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-32.49,18.76A.57.57,0,0,1,222,220.34Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M222,135.91a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-32.49,18.76A.57.57,0,0,1,222,135.91Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222,140.6a.49.49,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-32.49,18.76A.57.57,0,0,1,222,140.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222,145.3a.5.5,0,0,1-.25-.94l32.49-18.76a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-32.49,18.76A.59.59,0,0,1,222,145.3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M222,150a.5.5,0,0,1-.25-.94l32.49-18.76a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-32.49,18.76A.59.59,0,0,1,222,150Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M222,154.68a.5.5,0,0,1-.25-.94L254.23,135a.5.5,0,0,1,.5.87l-32.49,18.76A.47.47,0,0,1,222,154.68Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222,159.37a.5.5,0,0,1-.25-.94l32.49-18.76a.49.49,0,0,1,.68.19.5.5,0,0,1-.18.68L222.24,159.3A.47.47,0,0,1,222,159.37Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M222,164.06a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68l32.49-18.77a.5.5,0,0,1,.68.19.49.49,0,0,1-.18.68L222.24,164A.47.47,0,0,1,222,164.06Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222,168.75a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68l32.49-18.77a.5.5,0,0,1,.68.19.49.49,0,0,1-.18.68l-32.49,18.76A.47.47,0,0,1,222,168.75Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M222,173.44a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68l32.49-18.77a.5.5,0,0,1,.68.19.49.49,0,0,1-.18.68l-32.49,18.76A.47.47,0,0,1,222,173.44Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M222,178.13a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l32.49-18.76a.5.5,0,1,1,.5.86l-32.49,18.76A.47.47,0,0,1,222,178.13Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M222,182.82a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68L238,172.5a.52.52,0,0,1,.69.19.5.5,0,0,1-.19.68l-16.24,9.38A.47.47,0,0,1,222,182.82Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7,290.58a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l106.38-61.41a.5.5,0,1,1,.5.86L148,290.52A.51.51,0,0,1,147.7,290.58Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.21,296.49a.5.5,0,0,1-.25-.93l106.38-61.42a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69L149.46,296.42A.45.45,0,0,1,149.21,296.49Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M151,302.28a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68L257.1,239.93a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69L151.23,302.21A.47.47,0,0,1,151,302.28Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.85,308.05a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69L259,245.7a.5.5,0,0,1,.5.86L153.1,308A.47.47,0,0,1,152.85,308.05Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155,313.68a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l106.38-61.41a.5.5,0,0,1,.5.86L155.26,313.61A.55.55,0,0,1,155,313.68Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M190,369.53a.5.5,0,0,1-.37-.17c-3.65-4.15-11.53-13.4-15.24-18.75-7.94-11.85-13.69-22.21-17.58-31.67a.51.51,0,0,1,.28-.66.5.5,0,0,1,.65.28c3.86,9.4,9.58,19.7,17.47,31.49,3.69,5.3,11.53,14.52,15.17,18.65a.49.49,0,0,1-.05.7A.46.46,0,0,1,190,369.53Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M258.51,277.94a.52.52,0,0,1-.44-.25.52.52,0,0,1,.19-.69l11.55-6.67a.5.5,0,0,1,.5.87l-11.55,6.67A.47.47,0,0,1,258.51,277.94Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M254.52,287.3a.5.5,0,0,1-.25-.93l18.79-10.86a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68l-18.79,10.86A.51.51,0,0,1,254.52,287.3Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M271.86,298.24a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l11.5-6.62a.5.5,0,1,1,.5.86l-11.5,6.63A.47.47,0,0,1,271.86,298.24Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M268.41,307.27a.5.5,0,0,1-.26-.93l18.54-11a.51.51,0,0,1,.69.18.49.49,0,0,1-.18.68l-18.54,11A.45.45,0,0,1,268.41,307.27Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M194.22,373.85a.5.5,0,0,1-.25-.93l107-61.78a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-107,61.77A.47.47,0,0,1,194.22,373.85Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M198.7,378a.5.5,0,0,1-.25-.93l107-61.77a.5.5,0,1,1,.5.86L199,377.93A.57.57,0,0,1,198.7,378Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M203,381.77a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l107-61.77a.5.5,0,1,1,.5.87l-107,61.77A.47.47,0,0,1,203,381.77Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M208.12,385.9a.5.5,0,0,1-.25-.93l107-61.77a.5.5,0,0,1,.68.18.5.5,0,0,1-.18.68l-107,61.78A.57.57,0,0,1,208.12,385.9Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M311.15,436.22a.5.5,0,0,1-.25-.93l20.31-11.73a.5.5,0,0,1,.5.87L311.4,436.15A.47.47,0,0,1,311.15,436.22Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M315.21,438.56a.5.5,0,0,1-.25-.93l20.31-11.72a.5.5,0,0,1,.5.86L315.46,438.5A.54.54,0,0,1,315.21,438.56Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M319.27,440.91A.5.5,0,0,1,319,440l20.31-11.73a.5.5,0,1,1,.5.87l-20.31,11.72A.45.45,0,0,1,319.27,440.91Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M347.71,415.11a.5.5,0,0,1-.25-.93l20.31-11.72a.5.5,0,1,1,.5.86L348,415.05A.57.57,0,0,1,347.71,415.11Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M351.77,417.46a.5.5,0,0,1-.25-.93l20.31-11.73a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69L352,417.39A.47.47,0,0,1,351.77,417.46Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M355.83,419.8a.5.5,0,0,1-.25-.93l20.31-11.73a.5.5,0,0,1,.5.87l-20.31,11.73A.54.54,0,0,1,355.83,419.8Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26,394a.5.5,0,0,1-.25-.93l20.31-11.73a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68l-20.31,11.73A.45.45,0,0,1,384.26,394Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M388.33,396.35a.5.5,0,0,1-.25-.93l20.31-11.73a.5.5,0,0,1,.5.87l-20.31,11.72A.47.47,0,0,1,388.33,396.35Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M392.39,398.7a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L412.45,386a.5.5,0,1,1,.5.86l-20.31,11.73A.47.47,0,0,1,392.39,398.7Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.25,220c-1.8,3.2-13.35,13.36-14.4,14.52s-2.28,2.22-3.32,3.19c-1.24,1.16-2.22,2.48-3.86,3.14a1.78,1.78,0,0,1-1.46.06c-.23-.12-.4-.32-.62-.44s-.8-.19-1.11-.43-.47-1-.92-1.35a3.87,3.87,0,0,0-.67-.26c-.41-.18-.67-.85-.84-1.24-.09-.21-.17-.68-.49-.64a19.52,19.52,0,0,0-2.46.77c-1.87.61-3.08.74-3.35-.17-.39-1.27,1.08-1.59,3.34-2.55s7-2.94,6.79-3.46-1.78-1.43-2.41-2.59-.42-2.63.43-2c.48.38,2.34,1.32,3.16,1.79s2.3,1.36,3.31,1,11.18-13,11.18-13,8.12-17.39,10.14-20.95,3.64-5.59,7-5.71l.42,6.42-.87,7.24S374.7,217.4,373.25,220Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.76,189.55s-3.29-.83-5.4,1.47-3,4.07-4.78,7.76S366.93,213,366.93,213a9.33,9.33,0,0,0,8.42,3.82L384.24,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,205.72a31,31,0,0,1,.61,7.81c-.23,3.44-2.68,9.75-2.68,9.75s1.93,1.75,7.17.93c4.27-.67,2.76-13.54.31-16A8.09,8.09,0,0,0,377.32,205.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,315.56a30.82,30.82,0,0,1,.49,5.15c.06,3.12.64,4.23.71,6.79.09,2.93-.42,4-1.61,5.68s-4.3,3.14-5.62.35-1.15-4.6-.73-7.48.49-4.61.74-6.87c.23-2,.49-3.52.49-3.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,291l10.29-.19c-.16,6.87-1.25,18.31-1.43,24.75,0,1.21,0,9.43-.42,11.92-.69,3.75-5.14,3.25-5.38,1s.29-11.83.27-12.82c0-4.13-1.9-14.92-2.91-22.34C398.37,293,398,291.35,398,291Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,310.22s.53,0,.62.46.12,1.33.33,2.18a12.19,12.19,0,0,1,.37,4.07c-.18,1-2.37,2.39-3.86,2.64a11.61,11.61,0,0,0-4.79,2.84,11.47,11.47,0,0,1-6.65,2.61c-2.5,0-4.24-.83-5.07-2.17s.75-1.5,3.61-3.35l2.22-1.44c4.52-3,6.18-4.54,7.46-7.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.08,308.61c.07-2.13-1-17.8-1-17.8l8.85,1c-2.09,12.49-2.26,16.74-2,18.56h0a1.66,1.66,0,0,1,.06.52c0,2.43-2.75,3.74-4.89,5.36a19.49,19.49,0,0,1-5.55,3.47c-1.65.56-4.69.77-5.08-.23a67.81,67.81,0,0,0,8.21-6.84C376.63,311.57,377,310.73,377.08,308.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92,216.85a37.35,37.35,0,0,1,6.47,13.34c2.92,11.8-1.67,37-1.67,37,.15,1.71,2.11,5.08,2.84,12.61.86,8.9-1.59,32.73-1.59,32.73a5.7,5.7,0,0,1-5.77.12s-6.23-35-7.34-43.86c-1-7.72-3-23.76-3-23.76l-4.46,23.72s.62,4.33.94,7.62c.51,5.21-4.56,31.33-4.56,31.33a7.17,7.17,0,0,1-5.74-.11s-2.25-33.75-2.72-40c-.48-6.45,1.19-21.49,2.43-33.47.37-3.6,2.2-14.74,2.84-17.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,245.07l-1.06-7.31a18.17,18.17,0,0,1-8.6-2.78,11,11,0,0,0,7.2,4l.67,6.54L387,265.92Z",
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,209.05c.11,2.15.53,7.26.53,7.26,8.76,5.93,21.29.54,21.29.54l1.82-12.46s-4.57-6.4-.28-13.15l-6.85-1.35-8.17-.67-4.75.43c-2.68,2-4.46,6-5.32,8.16A10.35,10.35,0,0,0,379.1,209.05Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.1,209.05c.11,2.15.53,7.26.53,7.26,8.76,5.93,21.29.54,21.29.54l1.82-12.46s-4.57-6.4-.28-13.15l-6.85-1.35-8.17-.67-4.75.43c-2.68,2-4.46,6-5.32,8.16A10.35,10.35,0,0,0,379.1,209.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,189.67s7.51.65,9,1.35,3.92,4.94,1.73,11.11-4.19,13.39-4,14.85,5.46,9,5.46,9a14.26,14.26,0,0,1-4.82,2.31L401,222.41l.63,6.23a31.93,31.93,0,0,1-8.28.87S390.82,205.62,396.3,189.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.79 215.07 382.98 216.57 394.26 241.58 373.06 239.62 360.79 215.07",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.79 215.07 382.98 216.57 394.26 241.58 373.06 239.62 360.79 215.07",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.33,232.38a5,5,0,0,0,4,3.17,11.15,11.15,0,0,0,5.77-1.08l-.95-2.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.71,217.68l-.33-.77c-.19-.43,1.05-.69,2.76-.58l3.26.21c1.71.11,3.24.54,3.42,1l.33.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,214.92c-.12-.26.37-.43,1.09-.38l1.29.11s-.7-1.67,2.15-1.59A4.36,4.36,0,0,1,374,215l1.39.12a2.52,2.52,0,0,1,1.64.6l.25.47-11.43-.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.32,215.5c1.05.05,1.49.11,1.77.76s.5,1.31.5,1.31l5.06.35s-.43-.95-.58-1.32,0-.64.78-.58v-.32l-7.92-.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.59,217.78l-.33-.77c-.18-.43,1.05-.69,2.76-.58l3.27.21c1.7.11,3.23.54,3.42,1l.32.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.55,188.5H377.13V172.08a13.45,13.45,0,0,1,13.45-13.45h0A13.45,13.45,0,0,1,404,172.08V180A8.48,8.48,0,0,1,395.55,188.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,166.51c-.78.32-2.4,1.7-2.43,9.71,0,6.78,2.12,8.52,3.21,9s3.23.28,5.31,0l-.05,3.34a14.82,14.82,0,0,0-1.65,10.2c4.26-3.29,10.65-8.88,10.65-8.88l.2-9.41s1.19,1.22,3.3-.53c1.75-1.44,2.39-3.94,1.1-5.33a3,3,0,0,0-4.75.81c-4.44,0-6.35-4.95-6.64-8C387.47,168.55,383.19,169.49,380.79,166.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.22,172.43c4.48-.66,5.82-5,5.82-5s2.63-7-4.37-7.41c-10.76-.68-9.69,12.44-9.69,12.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,174.51a.84.84,0,1,0,.9-.8A.85.85,0,0,0,386.06,174.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,180.54l-2.31.67a1.19,1.19,0,0,0,1.47.86A1.27,1.27,0,0,0,386,180.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,172.43,381,171.3a1,1,0,0,0-1.4-.33A1.08,1.08,0,0,0,379.22,172.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9,171.53l1.81,1a1,1,0,0,0-.37-1.39A1.09,1.09,0,0,0,386.9,171.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.62,174.35a.85.85,0,0,0,.77.93.86.86,0,0,0,.9-.81.85.85,0,0,0-.77-.93A.86.86,0,0,0,379.62,174.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.76 173.88 383.66 179.35 381.02 178.46 383.76 173.88",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.92,185.47c2.15-.22,6.6-1.37,7.33-3.1a4.55,4.55,0,0,1-1.61,2.19c-1.34,1.09-5.74,2.25-5.74,2.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.84,228.93a14,14,0,0,0,4.29-1.25,10.55,10.55,0,0,1-2.41-.65,1.5,1.5,0,0,1-.92-1.82c.12-.3.85.06,2.17,0a15.82,15.82,0,0,1,4.61,0c.67.14,1.58.6,2.17.26a147.22,147.22,0,0,0,12.81-8.89h0l-3.9-11.66a15.48,15.48,0,0,1,1.06-13.9c2.65.46,4.7,1,6.68,8,2.08,7.4,5,17,4.84,20.06s-8.13,6.2-14.12,9.18c-2.53,1.26-6.71,3.66-8.35,4.51-5.67,2.95-8.42,2.67-10.39.75C379.23,230.47,380.43,229.36,383.84,228.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.37,190.54c5.37.33,6,4.47,7.53,8.57,1.45,3.82,3.33,13.89,3.33,13.89s-3.93,3.95-8.14,2.92l-3.73-11.69S397.92,195.2,403.37,190.54Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.87,305.65h0c.53-1.25,1.9-2.16,4-2.41a14.47,14.47,0,0,1,12,5.12c1.25,1.67,1.54,3.28,1,4.54h0l-34.32,89.92h0c-.67,1.89-2.61,3.27-5.64,3.64-5.79.7-13.31-2.51-16.81-7.16-1.84-2.45-2.19-4.8-1.29-6.59h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.87,308.36c2.5,3.34,1.18,6.45-3,6.95a14.46,14.46,0,0,1-12-5.12c-2.51-3.34-1.18-6.45,3-6.95A14.47,14.47,0,0,1,211.87,308.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76,279.51a8.7,8.7,0,0,1,7.27,3.1,2.75,2.75,0,0,1,.61,2.74h0l-11.13,26.12h0a2.78,2.78,0,0,1-2.4,1.45,8.74,8.74,0,0,1-7.28-3.09,2.79,2.79,0,0,1-.61-2.75L210.36,281h0A2.76,2.76,0,0,1,212.76,279.51Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76,279.51a8.7,8.7,0,0,1,7.27,3.1,2.75,2.75,0,0,1,.61,2.74h0l-11.13,26.12h0a2.78,2.78,0,0,1-2.4,1.45,8.74,8.74,0,0,1-7.28-3.09,2.79,2.79,0,0,1-.61-2.75L210.36,281h0A2.76,2.76,0,0,1,212.76,279.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,293l.77.45s0,0,0,0l.12.07v0l.15.08.16.09a16.82,16.82,0,0,0,1.52.79c.63.32,1.28.6,1.92.85a18.57,18.57,0,0,0,1.76.65,296,296,0,0,0,2,.58c.35.1.68.19,1,.26a7,7,0,0,0,.77.16l.25.05,5-11.69h0a2.75,2.75,0,0,0-.61-2.74,6.24,6.24,0,0,0-1.05-1.07,37.54,37.54,0,0,1-9.57,1.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.85,315l-36.21,91.3a15.79,15.79,0,0,0,4.27.13c3-.37,5-1.74,5.64-3.65h0l34.32-89.9c-.54,1.26-1.91,2.15-4,2.4A11.81,11.81,0,0,1,204.85,315Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,171.4c0-.75-.05-1.49-.11-2.23s-.09-1.46-.17-2.18c0-.49-.09-1-.15-1.45-.12-1.25-.3-2.49-.51-3.67-.09-.54-.19-1.09-.3-1.63s-.21-1-.31-1.52c-.32-1.37-.65-2.7-1-4-.2-.61-.39-1.21-.59-1.81a1,1,0,0,1-.09-.28c-.22-.59-.43-1.16-.65-1.72s-.52-1.3-.81-1.91-.41-.9-.65-1.34a7.17,7.17,0,0,0-.48-1c-.19-.39-.39-.79-.61-1.16a1.53,1.53,0,0,0-.16-.25c-.18-.33-.38-.67-.58-1s-.28-.42-.41-.63a32.67,32.67,0,0,0-3.18-4.23c-.2-.23-.41-.45-.59-.67s-.33-.35-.5-.52-.43-.42-.65-.65a20.41,20.41,0,0,0-1.92-1.72c-.32-.27-.65-.53-1-.77s-.67-.5-1-.74a18.66,18.66,0,0,0-1.65-1.08l-.44-.27-.09-.08h0L289,126.87h0l-.15-.09a33,33,0,0,0-16.46-4.16c-8.59,0-18.28,2.81-28.54,8.73C208.56,151.72,180,201.23,180,242c0,20.31,7.1,34.6,18.59,41.29l.1.06h0L209,289.39h0l.12.08v0l.15.08.16.09a16.82,16.82,0,0,0,1.52.79,20.4,20.4,0,0,0,1.92.85,17.61,17.61,0,0,0,1.76.65c.31.11.62.2.94.28a6.88,6.88,0,0,0,1,.29,9.88,9.88,0,0,0,1,.26,5.19,5.19,0,0,0,.76.17c.45.09.92.19,1.39.24a.86.86,0,0,0,.32,0c.55.09,1.11.17,1.65.23,9.52,1,20.58-1.69,32.41-8.51,35.28-20.37,63.88-69.91,63.88-110.62C318.07,173.33,318.05,172.37,318,171.4ZM201.65,267.5a62.3,62.3,0,0,1-2.16-16.71c0-38.6,28.24-87.51,61.66-106.81a59.76,59.76,0,0,1,15.64-6.47,34.34,34.34,0,0,1,8-1,25.19,25.19,0,0,1,4.08.32l.11,0c6.84,8.09,7.85,21.06,7.85,28,0,38.59-28.21,87.5-61.65,106.79-8.5,4.91-16.68,7.5-23.69,7.5a16.38,16.38,0,0,1-4.31-.55h0A30.42,30.42,0,0,1,201.65,267.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.89,171.57c0,20.51-8,43.91-20.45,64.26-.59,1-1.19,1.91-1.81,2.86s-1.05,1.64-1.6,2.45c-1.17,1.74-2.36,3.46-3.6,5.14-.59.8-1.18,1.59-1.79,2.37s-1.32,1.72-2,2.57q-1.93,2.43-4,4.73c-.89,1-1.8,2-2.71,3a103.78,103.78,0,0,1-23.74,19.4c-1.6.92-3.18,1.77-4.75,2.52a47.39,47.39,0,0,1-16.25,4.86c-.92.09-1.82.12-2.69.12-.46,0-.91,0-1.35,0h0a20.58,20.58,0,0,1-2.54-.27c-.41-.06-.81-.12-1.2-.21s-.78-.17-1.17-.29a18.69,18.69,0,0,1-10-6.48,16.41,16.41,0,0,0,4.3.55c7,0,15.2-2.59,23.7-7.5,33.44-19.28,61.64-68.2,61.64-106.79,0-6.94-1-19.9-7.84-28l-.11,0c8.71,1.39,13.67,7.32,16.46,14.17a40.34,40.34,0,0,1,1.91,6c0,.11,0,.22.07.34.09.36.18.74.25,1.11s.14.72.21,1.08a2,2,0,0,1,.05.28q.12.58.21,1.14c.21,1.44.39,2.83.51,4.17,0,.39.07.75.09,1.12s.05.56.06.83c0,.12,0,.24,0,.35,0,.3,0,.59.05.88a2.09,2.09,0,0,1,0,.25c0,.37,0,.74,0,1.09C308.88,170.29,308.89,171,308.89,171.57Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,288.88l-9.59-5.64C187.06,276.53,180,262.25,180,242c0-18.16,5.7-38.06,15.11-56.34L206,191.91c-9.43,18.28-15.67,38-15.67,56.14C190.32,267.91,197.08,282,208.14,288.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.46,133l-.09-.08h0L289,126.88h0l-.14-.09a32.88,32.88,0,0,0-16.47-4.17c-8.58,0-18.28,2.81-28.55,8.73-19.54,11.29-37,31.54-48.74,54.28L205.94,192l-.24.45c11.75-22.49,29.16-42.85,48.49-55,17.5-11,34.11-11.18,45.71-4.12Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.33,168.3c0,38.59-28.24,87.51-61.66,106.8A59.47,59.47,0,0,1,226,281.58a34.31,34.31,0,0,1-8.05,1,23,23,0,0,1-8.18-1.39c-4.15-3.48-6.65-8.52-8.15-13.7a62.3,62.3,0,0,1-2.16-16.71c0-38.6,28.24-87.51,61.66-106.81a59.76,59.76,0,0,1,15.64-6.47,34.34,34.34,0,0,1,8-1,23.08,23.08,0,0,1,8.18,1.4c4.15,3.47,6.65,8.52,8.15,13.7A62.25,62.25,0,0,1,303.33,168.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boy--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.14,343.48c1.89.42,5.5.8,5.5.8l2.59-5.49-5.81-2.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,339.38a38.47,38.47,0,0,0,14.67,4.17l3.12-4.7-15.68-10.57Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,339.38a38.47,38.47,0,0,0,14.67,4.17l3.12-4.7-15.68-10.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69,343.47l2.64.39,2-6s-2.59-1.24-2.66-1.2S171.69,343.47,171.69,343.47Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69,343.47l2.64.39,2-6s-2.59-1.24-2.66-1.2S171.69,343.47,171.69,343.47Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,306.08a6.31,6.31,0,0,0-6.42,3.32,13.37,13.37,0,0,0-1,6.77c.6,5.29,4.57,16.84,4.57,16.84Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,306.08a6.31,6.31,0,0,0-6.42,3.32,13.37,13.37,0,0,0-1,6.77c.6,5.29,4.57,16.84,4.57,16.84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,430.29c-.46.17-.72,1-.92,3.12-.12,1.3-.57,3,1.41,4.07a5,5,0,0,0,4.68-.05c1.72-1.06,2.58-3,4.59-4.61,1.77-1.38,4-2.4,5.41-4.92s1.2-4.19-1.73-4.19c-4.7,0-6.11,2.59-8.53,2.64C134.6,426.38,131.49,430.12,131,430.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,429.25v2.12c0,1,4.4,2.57,5.63.21.09-.2.57-3.1.57-3.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,442.59s-.83,0-1.16,3.41c-.13,1.3-.44,4,0,4.93s2.85,1.39,5.55,1.63a14.55,14.55,0,0,1,5.69,2.2,12.16,12.16,0,0,0,5.76,1.59c2.55,0,4.71-.25,6.53-1.69,1-.76,2.19-2.37,1.29-3.59a2.67,2.67,0,0,0-1.36-.71c-1.13-.43-2.28-.82-3.43-1.18a36.24,36.24,0,0,1-5.05-1.93c-2.38-1.18-5-2.49-6.83-4.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.42,440.83s0,1.57,0,2.46,1,2.24,3.78,2.16c1.93-.06,3.27-.57,3.2-2.16V441Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.81,401.2a58.13,58.13,0,0,1,2.55-11s-.7-9.5-1-18.51a239.43,239.43,0,0,1,.77-27.66s30.61-2.9,31.11,8.34-.23,39.85-.62,44.79-.8,9.57-1.84,18.75c-.9,7.92-2.36,25.09-2.36,25.09a7.41,7.41,0,0,1-7-.18s-2.3-23.06-2.57-28.76c-.34-7.38,1.38-11.46,1.38-11.46s-.65-4.64-1.79-14.2c-.8-6.75-1.87-14.43-1.87-14.43s-1,9.51-1.68,14.81c-.59,4.92-1.59,8.81-3.07,18-1.28,8-4.77,24.78-4.77,24.78a5.22,5.22,0,0,1-6-.3S128.81,408.1,129.81,401.2Z",
    style: {
      fill: "#263238"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M146.57,372l-1.45-9.4s-6-1.89-9-5.44c0,0,1.61,4.13,7.16,6.35l2.23,7.91.38,6.53Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.59 303.31 150.16 313.35 141.13 313.04 142 301.31 151.59 303.31",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,290.92s2.42,3.55,2.16,3.91a6.15,6.15,0,0,1-2,.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,290.33a3,3,0,1,1,3,2.91A2.95,2.95,0,0,1,154.29,290.33Zm.65,0A2.3,2.3,0,1,0,157.2,288,2.3,2.3,0,0,0,154.94,290.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.35,281.08c4.8.94,6.22,3,6.79,10.62.6,7.95-.17,10.46-1.2,11.55-.69.73-4.61.92-6.6.41-2.48-.64-8.1-2.54-10.79-6.49-3.15-4.66-4.06-11-.8-13.69C143.33,279.72,149.39,280.7,151.35,281.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52,303.86c2.06.23,4.85,0,5.42-.61a14.22,14.22,0,0,1-5.14-1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,283l-.15.15c-1,.93-2.18,1.53-3.17,2.41a7.44,7.44,0,0,0-2.22,3.66c-.31,1.16-.42,2.53-1.67,3.08,0,0-.84-3.06-3.42-2.63s-2.91,3.76-1.23,5.75,3.2,1.2,3.2,1.2,0,4.4-1.92,6.92a13.31,13.31,0,0,1-6.3-.06c-2.51-.49-6.1-3.57-7.65-6.86-3.26-7-3.58-13.27.87-15.24.44-3.24,3-4.73,5.85-5.44,4.32-1.06,8.42,1.45,12.7.42a27.48,27.48,0,0,1,2.67-.68.54.54,0,0,1,.31,0c.23.11.22.42.16.66a5.68,5.68,0,0,1-1.23,2.34,13.31,13.31,0,0,0,4.85-.7A6.25,6.25,0,0,1,158.89,283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.87,283,133,281.3a1.66,1.66,0,1,1,2.89,1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,294l-.14-3.32a1.66,1.66,0,1,1,.14,3.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.9 289.63 151.01 290.92 151.38 291.54 159.91 290.3 159.9 289.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.16,311.61c1.05-4.12,2.54-5.46,6.13-5.56a47.78,47.78,0,0,1,5.51.7c.38,1.75,4.88,2.93,9.43,2,1.36.39,5,1.37,6.07,1.78,3.23,1.17,4.79,4.52,5,15.14,0,0,.62,25.2,0,29.55a39.07,39.07,0,0,1-21.22,2c-9.69-2.17-10.84-6.2-10.84-6.2s.51-10.11.84-17.8c-.49-4.9-1.22-8.58-1.48-12.49A32.63,32.63,0,0,1,131.16,311.61Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.16,311.61c1.05-4.12,2.54-5.46,6.13-5.56a47.78,47.78,0,0,1,5.51.7c.38,1.75,4.88,2.93,9.43,2,1.36.39,5,1.37,6.07,1.78,3.23,1.17,4.79,4.52,5,15.14,0,0,.62,25.2,0,29.55a39.07,39.07,0,0,1-21.22,2c-9.69-2.17-10.84-6.2-10.84-6.2s.51-10.11.84-17.8c-.49-4.9-1.22-8.58-1.48-12.49A32.63,32.63,0,0,1,131.16,311.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,304.15l-.07,1s.47,1.37,3.21,1.88c4.61.85,6.22-.58,6.22-.58l.12-.83s.44-.18,1.19.4a39.49,39.49,0,0,1,3.19,3.73s-.88-.26-3.76,1a13.73,13.73,0,0,1-9,.34,4.94,4.94,0,0,1-3.28-3.69C139.5,306.49,141,303.8,141.79,304.15Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,304.15l-.07,1s.47,1.37,3.21,1.88c4.61.85,6.22-.58,6.22-.58l.12-.83s.44-.18,1.19.4a39.49,39.49,0,0,1,3.19,3.73s-.88-.26-3.76,1a13.73,13.73,0,0,1-9,.34,4.94,4.94,0,0,1-3.28-3.69C139.5,306.49,141,303.8,141.79,304.15Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,310.32c4.1.51,7.34,1.37,9.13,5.28,3,6.62,6.31,12.06,8.7,14.62,2.55,2.73,13,7.53,15.36,7.15s4.7-3.09,5.92-2.39-1,3.33-.89,3.92,4.42.28,6.44-1.15,2.77,1.52.15,4.58-7.52,3.3-12.85,2.23-16.18-3.61-20.27-7c-5-4.09-5.84-7.45-7.95-11.11C154,318.61,157.94,310.32,157.94,310.32Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,310.21s4.39,0,6.69,1.4,3.75,4.41,5.65,8.55a55.42,55.42,0,0,0,6.24,9.82c1,1.24,8.3,5.3,8.3,5.3a31.09,31.09,0,0,1-2.15,7.57s-7.34-1.84-11.76-4.21-11.14-11.86-11.14-11.86S154.44,320.5,157.34,310.21Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,310.21s4.39,0,6.69,1.4,3.75,4.41,5.65,8.55a55.42,55.42,0,0,0,6.24,9.82c1,1.24,8.3,5.3,8.3,5.3a31.09,31.09,0,0,1-2.15,7.57s-7.34-1.84-11.76-4.21-11.14-11.86-11.14-11.86S154.44,320.5,157.34,310.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,335a17.23,17.23,0,0,1-2.29,7.67,38.9,38.9,0,0,0,3.93.85s2.3-2.31,2.17-6.92Z",
    style: {
      fill: "#416259"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,335a17.23,17.23,0,0,1-2.29,7.67,38.9,38.9,0,0,0,3.93.85s2.3-2.31,2.17-6.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,337.13a.47.47,0,0,1-.46.46.47.47,0,0,1,0-.93A.47.47,0,0,1,186,337.13Z",
    style: {
      fill: "#455a64"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestBanner);
export default __webpack_public_path__ + "static/media/requestBanner.917a18585d22aef2203d2ef0ae04d9c4.svg";
export { ForwardRef as ReactComponent };